import React, { useState, useEffect, useRef, Fragment } from "react";
import AdminTrafficsaleService from "../../../API/Services/AdminService/AdminTrafficsaleService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import TrafficsaleOffcanvas from "./TrafficsaleOffcanvas";
import MainPagetitle from "../../layouts/MainPagetitle";
import { Offcanvas, Form, Row, Dropdown } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ClipLoader from "react-spinners/ClipLoader";
import DateComponent from "../../components/date/DateFormat";
import AccessField from "../../components/AccssFieldComponent/AccessFiled";
import Modal from "react-bootstrap/Modal";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ColumnReOrderPopup from "../../popup/ColumnReOrderPopup";
import BulkTrafficUpdate from "./BulkTrafficUpdate";
import AdminBuilderService from "../../../API/Services/AdminService/AdminBuilderService";
import { MultiSelect } from "react-multi-select-component";
import DatePicker from "react-datepicker";
import moment from 'moment';
import '../../pages/Subdivision/subdivisionList.css';
import Swal from "sweetalert2";
import PriceComponent from "../../components/Price/PriceComponent";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "react-tooltip";
import LazySubdivisionMultiSelect from "../../components/LazySubdivisionMultiSelect";

const TrafficsaleList = () => {
  const isFirstRender = useRef(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = JSON.parse(queryParams.get("page")) === 1 ? null : JSON.parse(queryParams.get("page"));

  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [excelLoading, setExcelLoading] = useState(false);
  const [excelDownload, setExcelDownload] = useState(false);
  const [selectedFileError, setSelectedFileError] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedMasterPlan, setSelectedMasterPlan] = useState([]);
  const [productTypeStatus, setProductTypeStatus] = useState([]);
  const [builderDropDown, setBuilderDropDown] = useState([]);
  const [gasProviderDropDown, setGasProviderDropDown] = useState([]);
  const [masterPlanDropDownList, setMasterPlanDropDownList] = useState([]);
  const [selectedBuilderName, setSelectedBuilderName] = useState([]);
  const [selectedSubdivisionName, setSelectedSubdivisionName] = useState([]);
  const [selectedBuilderIDByFilter, setSelectedBuilderIDByFilter] = useState([]);
  const [selectedAge, setSelectedAge] = useState([]);
  const [selectedSingle, setSelectedSingle] = useState([]);
  const [seletctedGasProvider, setSelectedGasProvider] = useState([]);
  const [selectedLandSales, setSelectedLandSales] = useState([]);
  const navigate = useNavigate();
  const [Error, setError] = useState("");
  const [trafficsaleList, setTrafficsaleList] = useState([]);
  const [trafficListCount, setTrafficListCount] = useState('');
  const [manageFilterOffcanvas, setManageFilterOffcanvas] = useState(false);
  const [manageCalculationFilterOffcanvas, setManageCalculationFilterOffcanvas] = useState(false);
  const [searchQuery, setSearchQuery] = useState(localStorage.getItem("searchQueryByWeeklyTrafficFilter") ? JSON.parse(localStorage.getItem("searchQueryByWeeklyTrafficFilter")) : "");
  const [sortConfig, setSortConfig] = useState(() => {
    const savedSortConfig = localStorage.getItem("sortConfigTraffics");
    return savedSortConfig ? JSON.parse(savedSortConfig) : [];
  });
  const [selectedFields, setSelectedFields] = useState(() => {
    const saved = localStorage.getItem("selectedFieldsTraffics");
    return saved ? JSON.parse(saved) : [];
  });
  const [selectionOrder, setSelectionOrder] = useState(() => {
    const saved = localStorage.getItem("selectionOrderTraffics");
    return saved ? JSON.parse(saved) : {};
  });
  const [sortOrders, setSortOrders] = useState(() => {
    const saved = localStorage.getItem("sortOrdersTraffics");
    return saved ? JSON.parse(saved) : {};
  });
  const [selectAll, setSelectAll] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [AllTrafficListExport, setAllTrafficistExport] = useState([]);
  const [exportmodelshow, setExportModelShow] = useState(false);
  const [pageChange, setPageChange] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 100;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const [npage, setNpage] = useState(0);
  const number = [...Array(npage + 1).keys()].slice(1);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [TrafficDetails, setTrafficDetails] = useState({
    subdivision: "",
    weekending: "",
    weeklytraffic: "",
    grosssales: "",
    cancelations: "",
    netsales: "",
    lotreleased: "",
    unsoldinventory: "",
    status: "",
  });
  const [manageAccessOffcanvas, setManageAccessOffcanvas] = useState(false);
  const [accessList, setAccessList] = useState({});
  const [accessRole, setAccessRole] = useState("Admin");
  const [accessForm, setAccessForm] = useState({});
  const [role, setRole] = useState("Admin");
  const [checkedItems, setCheckedItems] = useState({});
  const [manageAccessField, setManageAccessField] = useState(false);
  const [fieldList, setFieldList] = useState([]);
  // const fieldList = AccessField({ tableName: "traffic" });
  const [openDialog, setOpenDialog] = useState(false);
  const [columns, setColumns] = useState([]);
  const [draggedColumns, setDraggedColumns] = useState(columns);
  const [filter, setFilter] = useState(false);
  const [normalFilter, setNormalFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState(false);
  const handlePopupClose = () => setShowPopup(false);
  const [filterQuery, setFilterQuery] = useState({
    from: localStorage.getItem("from_TrafficSale") ? JSON.parse(localStorage.getItem("from_TrafficSale")) : "",
    to: localStorage.getItem("to_TrafficSale") ? JSON.parse(localStorage.getItem("to_TrafficSale")) : "",
    builder_name: localStorage.getItem("builder_name_TrafficSale") ? JSON.parse(localStorage.getItem("builder_name_TrafficSale")) : "",
    subdivision_name: localStorage.getItem("subdivision_name_TrafficSale") ? JSON.parse(localStorage.getItem("subdivision_name_TrafficSale")) : "",
    weeklytraffic: localStorage.getItem("weeklytraffic_TrafficSale") ? JSON.parse(localStorage.getItem("weeklytraffic_TrafficSale")) : "",
    cancelations: localStorage.getItem("cancelations_TrafficSale") ? JSON.parse(localStorage.getItem("cancelations_TrafficSale")) : "",
    netsales: localStorage.getItem("netsales_TrafficSale") ? JSON.parse(localStorage.getItem("netsales_TrafficSale")) : "",
    totallots: localStorage.getItem("totallots_TrafficSale") ? JSON.parse(localStorage.getItem("totallots_TrafficSale")) : "",
    lotreleased: localStorage.getItem("lotreleased_TrafficSale") ? JSON.parse(localStorage.getItem("lotreleased_TrafficSale")) : "",
    unsoldinventory: localStorage.getItem("unsoldinventory_TrafficSale") ? JSON.parse(localStorage.getItem("unsoldinventory_TrafficSale")) : "",
    product_type: localStorage.getItem("product_type_TrafficSale") ? JSON.parse(localStorage.getItem("product_type_TrafficSale")) : "",
    area: localStorage.getItem("area_TrafficSale") ? JSON.parse(localStorage.getItem("area_TrafficSale")) : "",
    masterplan_id: localStorage.getItem("masterplan_id_TrafficSale") ? JSON.parse(localStorage.getItem("masterplan_id_TrafficSale")) : "",
    zipcode: localStorage.getItem("zipcode_TrafficSale") ? JSON.parse(localStorage.getItem("zipcode_TrafficSale")) : "",
    lotwidth: localStorage.getItem("lotwidth_TrafficSale") ? JSON.parse(localStorage.getItem("lotwidth_TrafficSale")) : "",
    lotsize: localStorage.getItem("lotsize_TrafficSale") ? JSON.parse(localStorage.getItem("lotsize_TrafficSale")) : "",
    zoning: localStorage.getItem("zoning_TrafficSale") ? JSON.parse(localStorage.getItem("zoning_TrafficSale")) : "",
    age: localStorage.getItem("age_TrafficSale") ? JSON.parse(localStorage.getItem("age_TrafficSale")) : "",
    single: localStorage.getItem("single_TrafficSale") ? JSON.parse(localStorage.getItem("single_TrafficSale")) : "",
    gasprovider: localStorage.getItem("gasprovider_TrafficSale") ? JSON.parse(localStorage.getItem("gasprovider_TrafficSale")) : "",
  });

  const getLocalStorageValue = (key, defaultValue = "") => {
    const value = localStorage.getItem(key);

    if (
      value === null ||
      value === undefined ||
      value === "undefined" ||
      value === "null" ||
      value === ""
    ) {
      return defaultValue;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return defaultValue;
    }
  };

  const [filterQueryCalculation, setFilterQueryCalculation] = useState({
    grosssales: getLocalStorageValue("grosssales_TrafficSale")
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);

  const [calculationData, setCalculationData] = useState({});
  const [handleCallBack, setHandleCallBack] = useState(false);
  const [canvasShowAdd, seCanvasShowAdd] = useState(false);
  const [canvasShowEdit, seCanvasShowEdit] = useState(false);

  const [weeklyTrafficOption, setWeeklyTrafficOption] = useState("");
  const [weeklyGrossSalesOption, setWeeklyGrossSalesOption] = useState("");
  const [weeklyCancellationsOption, setWeeklyCancellationsOption] = useState("");
  const [weeklyNetSalesOption, setWeeklyNetSalesOption] = useState("");
  const [totalLotsOption, setTotalLotsOption] = useState("");
  const [weeklyLotsReleaseForSaleOption, setWeeklyLotsReleaseForSaleOption] = useState("");
  const [weeklyUnsoldStandingInventoryOption, setWeeklyUnsoldStandingInventoryOption] = useState("");
  const [lotWidthOption, setLotWidthOption] = useState("");
  const [lotSizeOption, setLotSizeOption] = useState("");
  const [avgBasePriceAllOption, setAvgBasePriceAllOption] = useState("");
  const [avgBasePriceActiveOption, setAvgBasePriceActiveOption] = useState("");
  const [avgSqftAllOption, setAvgSqftAllOption] = useState("");
  const [avgSqftActiveOption, setAvgSqftActiveOption] = useState("");
  const [monthNetSoldOption, setMonthNetSoldOption] = useState("");
  const [yearNetSoldOption, setYearNetSoldOption] = useState("");
  const [avgNetSalesPerMonthSinceOpenOption, setAvgNetSalesPerMonthSinceOpenOption] = useState("");
  const [avgNetSalesPerMonthLastThreeMonthsOption, setAvgNetSalesPerMonthLastThreeMonthsOption] = useState("");
  const [minSqftActiveOption, setMinSqftActiveOption] = useState("");
  const [maxSqftActiveOption, setMaxSqftActiveOption] = useState("");
  const [minBasePriceActiveOption, setMinBasePriceActiveOption] = useState("");
  const [maxBasePriceActiveOption, setMaxBasePriceActiveOption] = useState("");
  const [totalNetSalesOption, setTotalNetSalesOption] = useState("");
  const [weeklyUnsoldLotsOption, setweeklyUnsoldLotsOption] = useState("");
  const [netSalesPerMonthOption, setNetSalesPerMonthOption] = useState("");

  const [weeklyTrafficResult, setWeeklyTrafficResult] = useState(0);
  const [weeklyGrossSalesResult, setWeeklyGrossSalesResult] = useState(0);
  const [weeklyCancellationsResult, setWeeklyCancellationsResult] = useState(0);
  const [weeklyNetSalesResult, setWeeklyNetSalesResult] = useState(0);
  const [totalLotsResult, setTotalLotsResult] = useState(0);
  const [weeklyLotsReleaseForSaleResult, setWeeklyLotsReleaseForSaleResult] = useState(0);
  const [weeklyUnsoldStandingInventoryResult, setWeeklyUnsoldStandingInventoryResult] = useState(0);
  const [lotWidthResult, setLotWidthResult] = useState(0);
  const [lotSizeResult, setLotSizeResult] = useState(0);
  const [avgBasePriceAllResult, setAvgBasePriceAllResult] = useState(0);
  const [avgBasePriceActiveResult, setAvgBasePriceActiveResult] = useState(0);
  const [avgSqftAllResult, setAvgSqftAllResult] = useState(0);
  const [avgSqftActiveResult, setAvgSqftActiveResult] = useState(0);
  const [weeklyUnsoldLotsResult, setWeeklyUnsoldLotsResult] = useState(0);
  const [netSalesPerMonthResult, setNetSalesPerMonthResult] = useState(0);
  const [monthNetSoldResult, setMonthNetSoldResult] = useState(0);
  const [yearNetSoldResult, setYearNetSoldResult] = useState(0);
  const [totalNetSalesResult, setTotalNetSalesResult] = useState(0);
  const [avgNetSalesPerMonthSinceOpenResult, setAvgNetSalesPerMonthSinceOpenResult] = useState(0);
  const [avgNetSalesPerMonthLastThreeMonthsResult, setAvgNetSalesPerMonthLastThreeMonthsResult] = useState(0);
  const [minSqftActiveResult, setMinSqftActiveResult] = useState(0);
  const [maxSqftActiveResult, setMaxSqftActiveResult] = useState(0);
  const [minBasePriceActiveResult, setMinBasePriceActiveResult] = useState(0);
  const [maxBasePriceActiveResult, setMaxBasePriceActiveResult] = useState(0);

  const handleSortingPopupClose = () => setShowSortingPopup(false);
  const [showSortingPopup, setShowSortingPopup] = useState(false);
  const [fieldOptions, setFieldOptions] = useState([]);
  const [samePage, setSamePage] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectCheckBox, setSelectCheckBox] = useState(false);


  const SyestemUserRole = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).role
    : "";

  const handleSelectBuilderNameChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.label).join(', ');
    const selectedValues = selectedItems.map(item => item.value);
    setSelectedBuilderName(selectedItems);
    setSelectedBuilderIDByFilter(selectedValues);
    setFilterQuery(prevState => ({
      ...prevState,
      builder_name: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleSelectSubdivisionNameChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.label).join(', ');
    setSelectedSubdivisionName(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      subdivision_name: selectedNames
    }));
    setNormalFilter(true);
  };

  useEffect(() => {
    if(handleCallBack && calculationData) {
      Object.entries(calculationData).forEach(([field, value]) => {
        handleSelectChange(value, field);
    });
    }
  },[handleCallBack, AllTrafficListExport, trafficsaleList]);

  useEffect(() => {
    if(selectedLandSales?.length === 0) {
      setHandleCallBack(false);
    }
  },[selectedLandSales]);

  useEffect(() => {
    if (selectedSubdivisionName?.length === 0) {
      setFilterQuery(prevState => ({
        ...prevState,
        subdivision_name: ""
      }));
    }
  }, [selectedSubdivisionName]);

  useEffect(() => {
    if (selectedFields) {
      localStorage.setItem("selectedFieldsTraffics", JSON.stringify(selectedFields));
    }
    if (selectionOrder) {
      localStorage.setItem("selectionOrderTraffics", JSON.stringify(selectionOrder));
    }
    if (sortOrders) {
      localStorage.setItem("sortOrdersTraffics", JSON.stringify(sortOrders));
    }
  }, [selectedFields, selectionOrder, sortOrders]);

  useEffect(() => {
    if (localStorage.getItem("selectedBuilderNameByFilter_TrafficSale")) {
      const selectedBuilderName = JSON.parse(localStorage.getItem("selectedBuilderNameByFilter_TrafficSale"));
      handleSelectBuilderNameChange(selectedBuilderName);
    }
    if (localStorage.getItem("selectedSubdivisionNameByFilter_TrafficSale")) {
      const selectedSubdivisionName = JSON.parse(localStorage.getItem("selectedSubdivisionNameByFilter_TrafficSale"));
      handleSelectSubdivisionNameChange(selectedSubdivisionName);
    }
    if (localStorage.getItem("productTypeStatusByFilter_TrafficSale")) {
      const productTypeStatus = JSON.parse(localStorage.getItem("productTypeStatusByFilter_TrafficSale"));
      handleSelectProductTypeChange(productTypeStatus);
    }
    if (localStorage.getItem("selectedAreaByFilter_TrafficSale")) {
      const selectedArea = JSON.parse(localStorage.getItem("selectedAreaByFilter_TrafficSale"));
      handleSelectAreaChange(selectedArea);
    }
    if (localStorage.getItem("selectedMasterPlanByFilter_TrafficSale")) {
      const selectedMasterPlan = JSON.parse(localStorage.getItem("selectedMasterPlanByFilter_TrafficSale"));
      handleSelectMasterPlanChange(selectedMasterPlan);
    }
    if (localStorage.getItem("selectedAgeByFilter_TrafficSale")) {
      const selectedAge = JSON.parse(localStorage.getItem("selectedAgeByFilter_TrafficSale"));
      handleSelectAgeChange(selectedAge);
    }
    if (localStorage.getItem("selectedSingleByFilter_TrafficSale")) {
      const selectedSingle = JSON.parse(localStorage.getItem("selectedSingleByFilter_TrafficSale"));
      handleSelectSingleChange(selectedSingle);
    }
    if (localStorage.getItem("seletctedGasProviderByFilter_TrafficSale")) {
      const seletctedGasProvider = JSON.parse(localStorage.getItem("seletctedGasProviderByFilter_TrafficSale"));
      handleGasProviderChange(seletctedGasProvider);
    }
  }, []);

  useEffect(() => {
    setSearchQuery(filterString());
  }, [filterQuery]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; 
    }

    if (localStorage.getItem("usertoken")) {
      if (!manageFilterOffcanvas) {
        if(page === currentPage){
          return;
        } else {
          GetTrafficsaleList(page === null ? currentPage : JSON.parse(page), sortConfig);
        }
      }
    } else {
      navigate("/");
    }
  }, [currentPage]);

  const bulkTrafficsale = useRef();

  const handleEditCheckboxChange = (e, userId) => {
    if (e.target.checked) {
      setSelectedLandSales((prevSelectedUsers) => [...prevSelectedUsers, userId]);
    } else {
      setSelectedLandSales((prevSelectedUsers) => prevSelectedUsers.filter((id) => id !== userId));
    }
  };

  const HandlePopupDetailClick = (e) => {
    setShowPopup(true);
  };

  const setLocalStorageValue = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value ?? ""));
  };

  const HandleFilterForm = (e) => {
    e.preventDefault();

    if (filterQuery.from == "" || filterQuery.to == "") {
      setShowPopup(true);
      if (filterQuery.from == "" && filterQuery.to == "") {
        setMessage("Please select from and to date.");
      } else if (filterQuery.from == "") {
        setMessage("Please select from date.");
      } else if (filterQuery.to == "") {
        setMessage("Please select to date.");
      }
      return;
    } else {
      let startDate = moment(filterQuery.from);
      let endDate = moment(filterQuery.to);
      let days = endDate.diff(startDate, 'days', true);
      let totaldays = Math.ceil(days) + 1;
      // if (totaldays < 367) {
        e.preventDefault();
        setFilter(false);
        setNormalFilter(false);
        setManageFilterOffcanvas(false);

        GetTrafficsaleList(1, sortConfig);

        localStorage.setItem("selectedBuilderNameByFilter_TrafficSale", JSON.stringify(selectedBuilderName));
        localStorage.setItem("selectedSubdivisionNameByFilter_TrafficSale", JSON.stringify(selectedSubdivisionName));
        localStorage.setItem("productTypeStatusByFilter_TrafficSale", JSON.stringify(productTypeStatus));
        localStorage.setItem("selectedAreaByFilter_TrafficSale", JSON.stringify(selectedArea));
        localStorage.setItem("selectedMasterPlanByFilter_TrafficSale", JSON.stringify(selectedMasterPlan));
        localStorage.setItem("selectedAgeByFilter_TrafficSale", JSON.stringify(selectedAge));
        localStorage.setItem("selectedSingleByFilter_TrafficSale", JSON.stringify(selectedSingle));
        localStorage.setItem("seletctedGasProviderByFilter_TrafficSale", JSON.stringify(seletctedGasProvider));
        localStorage.setItem("from_TrafficSale", JSON.stringify(filterQuery.from));
        localStorage.setItem("to_TrafficSale", JSON.stringify(filterQuery.to));
        localStorage.setItem("builder_name_TrafficSale", JSON.stringify(filterQuery.builder_name));
        localStorage.setItem("subdivision_name_TrafficSale", JSON.stringify(filterQuery.subdivision_name));
        localStorage.setItem("weeklytraffic_TrafficSale", JSON.stringify(filterQuery.weeklytraffic));
        localStorage.setItem("cancelations_TrafficSale", JSON.stringify(filterQuery.cancelations));
        localStorage.setItem("netsales_TrafficSale", JSON.stringify(filterQuery.netsales));
        localStorage.setItem("totallots_TrafficSale", JSON.stringify(filterQuery.totallots));
        localStorage.setItem("lotreleased_TrafficSale", JSON.stringify(filterQuery.lotreleased));
        localStorage.setItem("unsoldinventory_TrafficSale", JSON.stringify(filterQuery.unsoldinventory));
        localStorage.setItem("product_type_TrafficSale", JSON.stringify(filterQuery.product_type));
        localStorage.setItem("area_TrafficSale", JSON.stringify(filterQuery.area));
        localStorage.setItem("masterplan_id_TrafficSale", JSON.stringify(filterQuery.masterplan_id));
        localStorage.setItem("zipcode_TrafficSale", JSON.stringify(filterQuery.zipcode));
        localStorage.setItem("lotwidth_TrafficSale", JSON.stringify(filterQuery.lotwidth));
        localStorage.setItem("lotsize_TrafficSale", JSON.stringify(filterQuery.lotsize));
        localStorage.setItem("zoning_TrafficSale", JSON.stringify(filterQuery.zoning));
        localStorage.setItem("age_TrafficSale", JSON.stringify(filterQuery.age));
        localStorage.setItem("single_TrafficSale", JSON.stringify(filterQuery.single));
        localStorage.setItem("gasprovider_TrafficSale", JSON.stringify(filterQuery.gasprovider));

        setLocalStorageValue("grosssales_TrafficSale", filterQueryCalculation.grosssales);

        localStorage.setItem("searchQueryByWeeklyTrafficFilter", JSON.stringify(searchQuery));
        // setFilterQueryCalculation({
        //   grosssales: ""
        // });
      // } else {
      //   setShowPopup(true);
      //   setMessage("Please select date between 366 days.");
      //   return;
      // }
    }
  };

  const resetSelection = () => {
    setSelectAll(false);
    setSelectedColumns([]);
  };

  const clearTrafficDetails = () => {
    setTrafficDetails({
      subdivision: "",
      weekending: "",
      weeklytraffic: "",
      grosssales: "",
      cancelations: "",
      netsales: "",
      lotreleased: "",
      unsoldinventory: "",
      status: "",
    });
  };

  const checkFieldExist = (fieldName) => {
    return fieldList.includes(fieldName.trim());
  };

  const areaOption = [
    { value: "BC", label: "BC" },
    { value: "E", label: "E" },
    { value: "H", label: "H" },
    { value: "IS", label: "IS" },
    { value: "L", label: "L" },
    { value: "MSQ", label: "MSQ" },
    { value: "MV", label: "MV" },
    { value: "NLV", label: "NLV" },
    { value: "NW", label: "NW" },
    { value: "P", label: "P" },
    { value: "SO", label: "SO" },
    { value: "SW", label: "SW" }
  ];

  const handleSelectAreaChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedArea(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      area: selectedValues
    }));
    setNormalFilter(true);
  };

  const productTypeOptions = [
    { value: "DET", label: "DET" },
    { value: "ATT", label: "ATT" },
    { value: "HR", label: "HR" },
    { value: "AC", label: "AC" }
  ];

  const handleSelectProductTypeChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setProductTypeStatus(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      product_type: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleSelectMasterPlanChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedMasterPlan(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      masterplan_id: selectedValues
    }));
    setNormalFilter(true);
  };

  // const headers = [
  //   { label: 'Week Ending', key: 'WeekEnding' },
  //   { label: 'Builder Name', key: 'BuilderName' },
  //   { label: 'Subdivision Name', key: 'SubdivisionName' },
  //   { label: 'Weekly Traffic', key: 'WeeklyTraffic' },
  //   { label: 'Weekly Gross Sales', key: 'WeeklyGrossSales' },
  //   { label: 'Weekly Cancellations', key: 'WeeklyCancellations' },
  //   { label: 'Weekly Net Sales', key: 'WeeklyNetSales' },
  //   { label: 'Total Lots', key: 'TotalLots' },
  //   { label: 'Weekly Lots Released for Sales', key: 'WeeklyLotsReleaseForSale' },
  //   { label: 'Weekly Unsold Standing Inventory', key: 'WeeklyUnsoldStandingInventory' },
  //   { label: 'Product Type', key: 'ProductType' },
  //   { label: 'Area', key: 'Area' },
  //   { label: 'Master Plan', key: 'MasterPlan' },
  //   { label: 'ZIP Code', key: 'ZipCode' },
  //   { label: 'Lot Width', key: 'LotWidth' },
  //   { label: 'Lot Size', key: 'LotSize' },
  //   { label: 'Zoning', key: 'Zoning' },
  //   { label: 'Age Restricted', key: 'AgeRestricted' },
  //   { label: 'All Single Story', key: 'AllSingleStory' },
  //   { label: 'Pk Record id', key: 'pkRecordID' },
  //   { label: 'Fk Sub id', key: 'fkSubID' },
  //   { label: 'Avg Base Price All', key: 'avg_base_price_all' },
  //   { label: 'Avg Base Price Active', key: 'avg_base_price_active' },
  //   { label: 'Avg Sqft All', key: 'avg_sqft_all' },
  //   { label: 'Avg Sqft Active', key: 'avg_sqft_active' },
  //   { label: 'Sqft Group', key: 'sqft_group' },
  //   { label: 'Price Group', key: 'price_group' },
  //   { label: 'Jurisdiction', key: 'juridiction' },
  //   { label: "Gas Provider", key: "gasprovider" },
  // ];

  // const exportColumns = [
  //   { label: 'Week Ending', key: 'WeekEnding' },
  //   { label: 'Builder Name', key: 'BuilderName' },
  //   { label: 'Subdivision Name', key: 'SubdivisionName' },
  //   { label: 'Area', key: 'Area' },
  //   { label: 'Product Type', key: 'ProductType' },
  //   { label: 'Weekly Traffic', key: 'WeeklyTraffic' },
  //   { label: 'Weekly Gross Sales', key: 'WeeklyGrossSales' },
  //   { label: 'Weekly Cancellations', key: 'WeeklyCancellations' },
  //   { label: 'Weekly Net Sales', key: 'WeeklyNetSales' },
  //   { label: 'Month Net Sold', key: 'MonthNetSold' },
  //   { label: 'Year Net Sold', key: 'YearNetSold' },
  //   { label: 'Total Lots', key: 'TotalLots' },
  //   { label: 'Weekly Lots Released for Sales', key: 'WeeklyLotsReleaseForSale' },
  //   { label: 'Weekly Unsold Lots', key: 'WeeklyUnsoldLots' },
  //   { label: 'Total Net Sales', key: 'TotalNetSales' },
  //   { label: 'Open Since', key: 'OpenSince' },
  //   { label: 'Avg Net Sales Per Month Since Open', key: 'AvgNetSalesPerMonthSinceOpen' },
  //   { label: 'Net Sales Per Month Last 3 Months', key: 'NetSalesPerMonthLast3Months' },
  //   { label: 'Avg Net Sales Per Month Last 3 Months', key: 'AvgNetSalesPerMonthLast3Months' },
  //   { label: 'Weekly Unsold Standing Inventory', key: 'WeeklyUnsoldStandingInventory' },
  //   { label: 'Min Sqft Active', key: 'MinSqftActive' },
  //   { label: 'Max Sqft Active', key: 'MaxSqftActive' },
  //   { label: 'Min Base Price Active', key: 'MinBasePriceActive' },
  //   { label: 'Max Base Price Active', key: 'MaxBasePriceActive' },
  //   { label: 'Master Plan', key: 'MasterPlan' },
  //   { label: 'ZIP Code', key: 'ZipCode' },
  //   { label: 'Age Restricted', key: 'AgeRestricted' },
  //   { label: 'All Single Story', key: 'AllSingleStory' },
  //   { label: 'Avg Base Price Active', key: 'avg_base_price_active' },
  //   { label: 'Avg Base Price All', key: 'avg_base_price_all' },
  //   { label: 'Avg Sqft Active', key: 'avg_sqft_active' },
  //   { label: 'Avg Sqft All', key: 'avg_sqft_all' },
  //   { label: 'Fk Sub id', key: 'fkSubID' },
  //   { label: 'Date Added', key: 'DateAdded' },
  //   { label: 'Jurisdiction', key: 'juridiction' },
  // { label: "Gas Provider", key: "gasprovider" },
  //   { label: 'Lot Size', key: 'LotSize' },
  //   { label: 'Lot Width', key: 'LotWidth' },
  //   { label: 'Pk Record id', key: 'pkRecordID' },
  //   { label: 'Price Group', key: 'price_group' },
  //   { label: 'Sqft Group', key: 'sqft_group' },
  //   { label: 'Zoning', key: 'Zoning' },
  // ];

  // 1. Helper function to match export labels to accessList field names
  const getAccessFieldName = (label) => {
    // if (label === 'Pk Record id') return '__pkRecordID';
    // if (label === 'Fk Sub id') return '_fkSubID';
    // Add any other specific label-to-fieldname mappings here if needed
    return label;
  };

  // 2. Dynamically filter the export columns based on the user's access
  const filteredExportColumns = columns.filter(col => {
    const fieldName = getAccessFieldName(col.label);
    return checkedItems[fieldName] === true;
  });

  const handleSelectAllToggle = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    if (newSelectAll) {
      // setSelectedColumns(exportColumns.map(col => col.label));
      setSelectedColumns(filteredExportColumns.map(col => col.label));
    } else {
      setSelectedColumns([]);
    }
  };

  const handleColumnToggle = (column) => {
    const updatedColumns = selectedColumns.includes(column)
      ? selectedColumns.filter((col) => col !== column)
      : [...selectedColumns, column];
    setSelectedColumns(updatedColumns);
    // setSelectAll(updatedColumns.length === exportColumns.length);
    setSelectAll(updatedColumns.length === filteredExportColumns.length);
  };

  const handleDownloadExcel = async () => {
      setExcelDownload(true);
  
      try {
        const exportPayload = {
          ...buildTrafficsalePayload(currentPage, sortConfig),
          columns: selectedColumns,
        };
  
        const response = await AdminTrafficsaleService.export(exportPayload).blob();
  
        const downloadUrl = URL.createObjectURL(response);
        const a = document.createElement("a");
  
        a.href = downloadUrl;
        a.setAttribute("download", "weekly_trafficsales.xlsx");
        document.body.appendChild(a);
  
        setExcelDownload(false);
        setExportModelShow(false);
  
        swal({
          text: "Download Completed",
        }).then((willDownload) => {
          if (willDownload) {
            a.click();
            a.parentNode.removeChild(a);
            resetSelection();
          }
        });
      } catch (error) {
        setExcelDownload(false);
        setExportModelShow(false);
  
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        }
      }
    };

  // const handleDownloadExcel = async () => {
  //   const isAnyFilterApplied = Object.values(filterQueryCalculation).some(query => query !== "");
  //   let sortConfigString = "";
  //   if (sortConfig !== null) {
  //     sortConfigString = "&sortConfig=" + stringifySortConfig(sortConfig);
  //   }

  //   setExcelDownload(true);
  //   if (isAnyFilterApplied) {
  //     let tableHeaders;
  //     if (selectedColumns.length > 0) {
  //       tableHeaders = selectedColumns;
  //     } else {
  //       tableHeaders = columns.map((c) => c.label);
  //     }
  //     const is_calculated = "&is_calculated";
  //     const response = await AdminTrafficsaleService.export(currentPage, sortConfigString, searchQuery, "", is_calculated).json();
  //     if (response.status) {
  //       const tableData = trafficsaleList?.map((row) => {
  //         return tableHeaders.map((header) => {
  //           switch (header) {
  //             case "Week Ending":
  //               return row.weekending || '';
  //             case "Builder Name":
  //               return row.builder?.name ?? '';
  //             case "Subdivision Name":
  //               return row.subdivision?.name ?? '';
  //             case "Area":
  //               return row.subdivision?.area || '';
  //             case "Product Type":
  //               return row.subdivision?.product_type || '';
  //             case "Weekly Traffic":
  //               return row.weeklytraffic || 0;
  //             case "Weekly Gross Sales":
  //               return row.grosssales || 0;
  //             case "Weekly Cancellations":
  //               return row.cancelations || 0;
  //             case "Weekly Net Sales":
  //               return row.netsales || 0;
  //             case "Month Net Sold":
  //               return row.subdivision?.month_net_sold || '';
  //             case "Year Net Sold":
  //               return row.subdivision?.year_net_sold || '';
  //             case "Total Lots":
  //               return row.subdivision?.totallots || '';
  //             case "Weekly Lots Released for Sales":
  //               return row.lotreleased || '';
  //             case "Weekly Unsold Lots":
  //               return row.subdivision?.unsoldlots || '';
  //             case "Total Net Sales":
  //               return row.subdivision?.total_net_sales || '';
  //             case "Open Since":
  //               return row.subdivision?.opensince || '';
  //             case "Avg Net Sales Per Month Since Open":
  //               return row.subdivision?.avg_net_sales_per_month_since_open || '';
  //             case "Net Sales Per Month Last 3 Months":
  //               return row.subdivision?.net_sales_per_month_last_three_months || '';
  //             // case "Avg Net Sales Per Month Last 3 Months":
  //             //   return row.subdivision?.avg_net_sales_per_month_last_three_months || '';
  //             case "Weekly Unsold Standing Inventory":
  //               return row.unsoldinventory || '';
  //             case "Min Sqft Active":
  //               return row.subdivision?.min_sqft_active || '';
  //             case "Max Sqft Active":
  //               return row.subdivision?.max_sqft_active || '';
  //             case "Min Base Price Active":
  //               return row.subdivision?.min_base_price_active || '';
  //             case "Max Base Price Active":
  //               return row.subdivision?.max_base_price_active || '';
  //             case "Master Plan":
  //               return row.subdivision?.masterplan_id || '';
  //             case "ZIP Code":
  //               return row.subdivision?.zipcode || '';
  //             case "Age Restricted":
  //               return row.subdivision?.age === 1 ? "Yes" : row.subdivision?.age === 0 ? "No" : '';
  //             case "All Single Story":
  //               return row.subdivision?.single === 1 ? "Yes" : row.subdivision?.single === 0 ? "No" : '';
  //             case "Avg Base Price Active":
  //               return row.subdivision?.avg_base_price_active || '';
  //             case "Avg Base Price All":
  //               return row.subdivision?.avg_base_price_all || '';
  //             case "Avg Sqft Active":
  //               return row.subdivision?.avg_sqft_active || '';
  //             case "Avg Sqft All":
  //               return row.subdivision?.avg_sqft_all || '';
  //               case "Fk sub id":
  //                 return row.subdivision?.subdivision_code || '';
  //             case "Date Added":
  //               return row.subdivision?.created_at || '';
  //             case "Jurisdiction":
  //               return row.subdivision?.juridiction || '';
  //             case "Lot Size":
  //               return row.subdivision?.lotsize || '';
  //             case "Lot Width":
  //               return row.subdivision?.lotwidth || '';
  //             case "Pk Record id":
  //               return row.id || '';
  //             case "Price Group":
  //               return row.subdivision?.price_group?.group || '';
  //             case "Sqft Group":
  //               return row.subdivision?.sqft_group || '';
  //             case "Zoning":
  //               return row.subdivision?.zoning || '';
  //             default:
  //               return '';
  //           }
  //         });
  //       });

  //       const workbook = XLSX.utils.book_new();
  //       const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableData]);

  //       // Optionally apply styles to the headers
  //       const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
  //       for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
  //         const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: C })];
  //         if (!cell.s) cell.s = {};
  //         cell.s.font = { name: 'Calibri', sz: 11, bold: false };
  //       }

  //       XLSX.utils.book_append_sheet(workbook, worksheet, 'Worksheet');

  //       const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //       const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //       setExportModelShow(false);
  //       setExcelDownload(false);
  //       swal({
  //         text: "Download Completed"
  //       }).then((willDelete) => {
  //         if (willDelete) {
  //           saveAs(data, 'weekly_trafficsales.xlsx');
  //           resetSelection();
  //         }
  //       });
  //     } else {
  //       setExportModelShow(false);
  //       setExcelDownload(false);
  //       return;
  //     }
  //   } else {
  //     try {
  //       var exportColumn = {
  //         columns: selectedColumns
  //       }
  //       const response = await AdminTrafficsaleService.export(currentPage, sortConfigString, searchQuery, exportColumn, "").blob();
  //       const downloadUrl = URL.createObjectURL(response);
  //       const a = document.createElement('a');
  //       a.href = downloadUrl;
  //       a.setAttribute('download', `weekly_trafficsales.xlsx`);
  //       document.body.appendChild(a);
  //       setExcelDownload(false);
  //       setExportModelShow(false);
  //       swal({
  //         text: "Download Completed"
  //       }).then((willDelete) => {
  //         if (willDelete) {
  //           a.click();
  //           a.parentNode.removeChild(a);
  //           setSelectedColumns([]);
  //         }
  //       });
  //     } catch (error) {
  //     }
  //   }
  // };

  const HandleRole = (e, role) => {
    if(e) {
      setRole(e.target.value);
      setAccessRole(e.target.value);
    } else {
      setRole(role);
      setAccessRole(role);
    }
  };

  const handleAccessForm = async (e) => {
    e.preventDefault();
    var userData = {
      form: accessForm,
      role: role,
      table: "traffic",
    };
    try {
      const data = await AdminTrafficsaleService.manageAccessFields(userData).json();
      if (data.status === true) {
        setManageAccessOffcanvas(false);
        setManageAccessField(true);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")));
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(accessList)) {
      const initialCheckedState = {};

      accessList.forEach((element) => {
        try {
          const parsedRoles = JSON.parse(element.role_name);
          initialCheckedState[element.field_name] = parsedRoles.includes(accessRole);
        } catch (error) {
          initialCheckedState[element.field_name] = false;
        }
        // initialCheckedState[element.field_name] = element.role_name.includes(accessRole);
      });
      setCheckedItems(initialCheckedState);
    }
  }, [accessList, accessRole]);

  useEffect(() => {
    if(localStorage.getItem("user")){
      const userRole = JSON.parse(localStorage.getItem("user")).role;
      HandleRole("", userRole);
    }
  },[]);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
    setAccessForm((prevAccessForm) => ({
      ...prevAccessForm,
      [name]: checked,
    }));
  };

  const getAccesslist = async () => {
    try {
      const response = await AdminTrafficsaleService.accessField();
      const responseData = await response.json();
      const filteredData = responseData.filter(
        (item) => item.field_name != "Weekly Unsold Lots"
      );
      setAccessList(filteredData);
      console.log("TrafficList:",filteredData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      getAccesslist();
    } else {
      navigate("/");
    }
  }, []);

  const prePage = () => {
    if (currentPage !== 1) {
      setPageChange(true);
      setCurrentPage(currentPage - 1);
    }
  };

  const changeCPage = (id) => {
    setCurrentPage(id);
    setPageChange(true);
  };

  const nextPage = () => {
    if (currentPage !== npage) {
      setPageChange(true);
      setCurrentPage(currentPage + 1);
    }
  };

  const trafficsale = useRef();

  const stringifySortConfig = (sortConfig) => {
    return sortConfig.map((sort) => `${sort.key}:${sort.direction}`).join(",");
  };

  const buildTrafficsalePayload = (
    pageNumber = 1,
    sortConfigData = [],
    customFilterQuery = null,
    customCalculationFilter = null
  ) => {
    const finalFilterQuery = customFilterQuery || filterQuery;
    const finalCalculationFilter = customCalculationFilter || filterQueryCalculation;

    return {
      page: pageNumber,
      sortConfig:
        Array.isArray(sortConfigData) && sortConfigData.length > 0
          ? stringifySortConfig(sortConfigData)
          : "",

      from: finalFilterQuery.from,
      to: finalFilterQuery.to,
      builder_name: finalFilterQuery.builder_name,
      subdivision_name: finalFilterQuery.subdivision_name,
      weeklytraffic: finalFilterQuery.weeklytraffic,
      cancelations: finalFilterQuery.cancelations,
      netsales: finalFilterQuery.netsales,
      totallots: finalFilterQuery.totallots,
      lotreleased: finalFilterQuery.lotreleased,
      unsoldinventory: finalFilterQuery.unsoldinventory,
      product_type: finalFilterQuery.product_type,
      area: finalFilterQuery.area,
      masterplan_id: finalFilterQuery.masterplan_id,
      zipcode: finalFilterQuery.zipcode,
      lotwidth: finalFilterQuery.lotwidth,
      lotsize: finalFilterQuery.lotsize,
      zoning: finalFilterQuery.zoning,
      age: finalFilterQuery.age,
      single: finalFilterQuery.single,
      gasprovider: finalFilterQuery.gasprovider,

      ...finalCalculationFilter,
    };
  };

  const GetTrafficsaleList = async (
    pageNumber = 1, 
    sortConfigData = [], 
    customFilterQuery = null,
    customCalculationFilter = null
  ) => {
    setIsLoading(true);
    setExcelLoading(true);
    setCurrentPage(pageNumber);

    const payload = buildTrafficsalePayload(
      pageNumber,
      sortConfigData,
      customFilterQuery,
      customCalculationFilter
    );

    // setSearchQuery(searchQuery);
    // localStorage.setItem("searchQueryByWeeklyTrafficFilter", JSON.stringify(searchQuery));
    try {
      // let sortConfigString = "";
      // if (sortConfig !== null) {
      //   sortConfigString = "&sortConfig=" + stringifySortConfig(sortConfig);
      // }
      const response = await AdminTrafficsaleService.index(payload);
      const responseData = await response.json();
      setIsLoading(false);
      setExcelLoading(false);
      setPageChange(false);
      setTrafficsaleList(responseData.data);
      setNpage(Math.ceil(responseData.meta.total / recordsPage));
      setTrafficListCount(responseData.meta.total);
      setHandleCallBack(true);
      if (responseData.meta.total > 100) {
        if(!pageChange){
          FetchAllPages(payload, responseData.data, responseData.meta.total);
        }
      } else {
        if(!pageChange){
          setAllTrafficistExport(responseData.data);
        }
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        setIsLoading(false);
        setExcelLoading(false);
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

  const FetchAllPages = async (basePayload, trafficsaleList, trafficListCount) => {
    setExcelLoading(true);
    const totalPages = Math.ceil(trafficListCount / recordsPage);
    let allData = [...trafficsaleList];

    for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
      if (pageNum === basePayload.page) continue;

      const payload = {
        ...basePayload,
        page: pageNum,
      };

      const pageResponse = await AdminTrafficsaleService.index(payload);
      const pageData = await pageResponse.json();
      allData = allData.concat(pageData.data);
    }
    setAllTrafficistExport(allData);
    setExcelLoading(false);
    setHandleCallBack(true);
  };

  const handleDelete = async (e) => {
    try {
      let responseData = await AdminTrafficsaleService.destroy(e).json();
      if (responseData.status === true) {
        GetTrafficsaleList(currentPage, sortConfig);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const handleBulkDelete = async (id) => {
    try {
      let responseData = await AdminTrafficsaleService.bulkdestroy(id).json();
      if (responseData.status === true) {
        GetTrafficsaleList(currentPage, sortConfig);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const handleCallback = () => {
    GetTrafficsaleList(currentPage, sortConfig);
    setSelectedLandSales([]);
  };

  const handleRowClick = async (id) => {
    setShowOffcanvas(true);
    setIsFormLoading(true);
    try {
      let responseData = await AdminTrafficsaleService.show(id).json();
      setTrafficDetails(responseData);
      setIsFormLoading(false);
      localStorage.removeItem("traffic_id");
    } catch (error) {
      if (error.name === "HTTPError") {
        setIsFormLoading(false);
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const HandleFilter = (e) => {
    const { name, value } = e.target;
    setFilterQuery((prevFilterQuery) => ({
      ...prevFilterQuery,
      [name]: value,
    }));
    setNormalFilter(true);
  };

  const filterString = () => {
    const queryString = Object.keys(filterQuery)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(filterQuery[key])}`
      )
      .join("&");

    return queryString ? `&${queryString}` : "";
  };

  const emptyFilterQuery = {
    from: "",
    to: "",
    builder_name: "",
    subdivision_name: "",
    weeklytraffic: "",
    cancelations: "",
    netsales: "",
    totallots: "",
    lotreleased: "",
    unsoldinventory: "",
    product_type: "",
    area: "",
    masterplan_id: "",
    zipcode: "",
    lotwidth: "",
    lotsize: "",
    zoning: "",
    age: "",
    single: "",
    gasprovider: "",
  };

  const emptyFilterQueryCalculation = {
    grosssales: ""
  };

  const HandleCancelFilter = (e) => {
    if (e) {
      e.preventDefault();
    }

    setFilter(false);
    setNormalFilter(false);
    setManageFilterOffcanvas(false);

    setFilterQuery(emptyFilterQuery);
    setFilterQueryCalculation(emptyFilterQueryCalculation);

    setSearchQuery("");

    setSelectedBuilderName([]);
    setSelectedSubdivisionName([]);
    setProductTypeStatus([]);
    setSelectedArea([]);
    setSelectedMasterPlan([]);
    setSelectedAge([]);
    setSelectedSingle([]);
    setSelectedGasProvider([]);
    setSelectedBuilderIDByFilter([]);

    const removeKeys = [
      "selectedBuilderNameByFilter_TrafficSale",
      "selectedSubdivisionNameByFilter_TrafficSale",
      "productTypeStatusByFilter_TrafficSale",
      "selectedAreaByFilter_TrafficSale",
      "selectedMasterPlanByFilter_TrafficSale",
      "selectedAgeByFilter_TrafficSale",
      "selectedSingleByFilter_TrafficSale",
      "seletctedGasProviderByFilter_TrafficSale",
      "from_TrafficSale",
      "to_TrafficSale",
      "builder_name_TrafficSale",
      "subdivision_name_TrafficSale",
      "weeklytraffic_TrafficSale",
      "cancelations_TrafficSale",
      "netsales_TrafficSale",
      "totallots_TrafficSale",
      "lotreleased_TrafficSale",
      "unsoldinventory_TrafficSale",
      "product_type_TrafficSale",
      "area_TrafficSale",
      "masterplan_id_TrafficSale",
      "zipcode_TrafficSale",
      "lotwidth_TrafficSale",
      "lotsize_TrafficSale",
      "zoning_TrafficSale",
      "age_TrafficSale",
      "single_TrafficSale",
      "gasprovider_TrafficSale",
      "setTrafficFilter",
      "grosssales_TrafficSale"
    ];

    removeKeys.forEach((key) => localStorage.removeItem(key));

    GetTrafficsaleList(1, sortConfig, emptyFilterQuery, emptyFilterQueryCalculation);
  };

  const handleOpenDialog = () => {
    setDraggedColumns(columns);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setDraggedColumns(columns);
    setOpenDialog(false);
  };

  const handleSaveDialog = () => {
    localStorage.setItem("draggedColumnsTrafficsales", JSON.stringify(draggedColumns));
    setColumns(draggedColumns);
    setOpenDialog(false);
  };

  const handleColumnOrderChange = (result) => {
    if (!result.destination) {
      return;
    }
    const newColumns = Array.from(draggedColumns);
    const [movedColumn] = newColumns.splice(result.source.index, 1);
    newColumns.splice(result.destination.index, 0, movedColumn);
    setDraggedColumns(newColumns);
  };

  // useEffect(() => {
  //   const draggedColumns = JSON.parse(localStorage.getItem("draggedColumnsTrafficsales"));
  //   if(draggedColumns) {
  //     setColumns(draggedColumns);
  //   } else {
  //     const mappedColumns = fieldList.map((data) => ({
  //       id: data.charAt(0).toLowerCase() + data.slice(1),
  //       label: data
  //     }));
  //     setColumns(mappedColumns);
  //   }
  // }, [fieldList]);

  useEffect(() => {
    const draggedColumns = JSON.parse(localStorage.getItem("draggedColumnsTrafficsales"));

    if (draggedColumns && draggedColumns.length > 0) {
      setColumns(draggedColumns);
    } else {
      const mappedColumns = fieldList.map((data) => ({
        id: data.charAt(0).toLowerCase() + data.slice(1),
        label: data
      }));

      const builderCol = mappedColumns.find(col => col.label === "Builder Name");
      const subdivisionCol = mappedColumns.find(col => col.label === "Subdivision Name");
      const weekEndingCol = mappedColumns.find(col => col.label === "Week Ending");

      const remainingCols = mappedColumns.filter(col =>
        col.label !== "Builder Name" &&
        col.label !== "Subdivision Name" &&
        col.label !== "Week Ending" &&
        col.label !== "Avg Net Sales Per Month Last 3 Months" &&
        col.label !== "Weekly Unsold Lots"
      );

      const defaultOrderedColumns = [
        builderCol,
        subdivisionCol,
        weekEndingCol,
        ...remainingCols
      ].filter(Boolean);

      setColumns(defaultOrderedColumns);
    }
  }, [fieldList]);

  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join('');
  }

  const applyFilters = () => {
    const isAnyFilterApplied = Object.values(filterQueryCalculation).some(query => query !== "");

    if (AllTrafficListExport.length === 0) {
      setTrafficsaleList(trafficsaleList);
      return;
    }

    let filtered = AllTrafficListExport;

const applyNumberFilter = (items, query, key) => {
  if (!query) return items;

  let operator = '=';
  let value = query.trim();

  // 1. Handle empty/null check first
  if (value === '!') {
    return items.filter(item => {
      const val = item[key];
      return val === null || val === '';
    });
  }

  // 2. Handle range (e.g., "209#300")
  if (value.includes('#')) {
    const [min, max] = value.split('#').map(v => parseFloat(v.trim()));
    return items.filter(item => {
      const val = parseFloat(item[key]);
      return !isNaN(val) && val >= min && val <= max;
    });
  }

  // 3. Detect standard comparison operator
  const match = query.match(/^(>=|<=|!=|>|<|=)(.*)$/);
  if (match) {
    operator = match[1];
    value = match[2].trim();
  }

  const numberValue = parseFloat(value);
  if (!isNaN(numberValue)) {
    return items.filter(item => {
      const val = parseFloat(item[key]);
      if (isNaN(val)) return false;

      if (operator === '>') return val > numberValue;
      if (operator === '<') return val < numberValue;
      if (operator === '>=') return val >= numberValue;
      if (operator === '<=') return val <= numberValue;
      if (operator === '!=') return val != numberValue;
      if (operator === '=' || operator === '==') return val == numberValue;

      return false;
    });
  }

  return items;
};

    filtered = applyNumberFilter(filtered, filterQueryCalculation.grosssales, 'grosssales');

    if (isAnyFilterApplied && !normalFilter) {
      setTrafficsaleList(filtered.slice(0, 100));
      setTrafficListCount(filtered.length);
      setNpage(Math.ceil(filtered.length / recordsPage));
      setNormalFilter(false);
      if(isAnyFilterApplied){
        setFilter(true);
      } else {
        setFilter(false);
      }
    } else {
      setTrafficsaleList(filtered.slice(0, 100));
      setTrafficListCount(filtered.length);
      setNpage(Math.ceil(filtered.length / recordsPage));
      setCurrentPage(1);
      setNormalFilter(false);
      if(isAnyFilterApplied){
        setFilter(true);
      } else {
        setFilter(false);
      }
    }
  };

  // useEffect(() => {
  //   if (filter) {
  //     applyFilters();
  //   }
  // }, [filter]);

  useEffect(() => {
    if(manageFilterOffcanvas){
      GetBuilderDropDownList();
      GetMasterPlanDropDownList();
      GetGasProviderDropDownList();
    }
  }, [manageFilterOffcanvas]);

  const GetBuilderDropDownList = async () => {
    try {
      const response = await AdminBuilderService.builderDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((builder) => ({
        label: builder.name,
        value: builder.id,
      }));
      setBuilderDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const GetMasterPlanDropDownList = async () => {
    try {
      const response = await AdminBuilderService.masterPlanDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((masterPlan) => ({
        label: masterPlan.label,
        value: masterPlan.value,
      }));
      setMasterPlanDropDownList(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const GetGasProviderDropDownList = async () => {
    try {
      const response = await AdminBuilderService.gasProviderDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((gas_provider) => ({
        label: gas_provider.label,
        value: gas_provider.value,
      }));
      setGasProviderDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilterQueryCalculation(prevFilterQuery => ({
      ...prevFilterQuery,
      [name]: value
    }));
    setFilter(true);
  };

  const ageOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ];

  const singleOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ];

  const handleSelectAgeChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setSelectedAge(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      age: selectedNames
    }));
    setNormalFilter(true);
  };

  const handleSelectSingleChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setSelectedSingle(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      single: selectedNames
    }));
    setNormalFilter(true);
  };

  // const gasProviderOption = [
  //   { value: "SOUTHWEST GAS", label: "SOUTHWEST GAS" },
  // ];

  const handleGasProviderChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedGasProvider(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      gasprovider: selectedValues
    }));
  };

  const handleFileChange = async (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUploadClick = async () => {
    const file = selectedFile;

    if (file && file.type === "text/csv") {
      setLoading(true);
      setSelectedFileError("");
      setError("");
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = async () => {
        var iFile = fileReader.result;
        setSelectedFile(iFile);
        const inputData = {
          csv: iFile,
        };
        try {
          let responseData = await AdminTrafficsaleService.import(inputData).json();
          setSelectedFile("");
          document.getElementById("fileInput").value = null;
          setLoading(false);
          if (responseData.failed_records > 0) {
            let message = [];
            const problematicRows = responseData.failed_records_details.map(detail => detail.row).join(', ');
            const problematicRowsError = responseData.failed_records_details.map(detail => detail.error).join(', ');
            message += '\nRecord Imported: ' + responseData.successful_records;
            message += '\nFailed Record Count: ' + responseData.failed_records;
            message += '\nProblematic Record Rows: ' + problematicRows + '.';
            message += '\nErrors: ' + problematicRowsError + '.';
            message += '\nLast Row: ' + responseData.last_processed_row;
            setShow(false);
            swal({
              title: responseData.message,
              text: message,
            }).then((willDelete) => {
              if (willDelete) {
                GetTrafficsaleList(currentPage, sortConfig);
              }
            });
          }  else {
            if (responseData.message) {
              let message = [];
              const updatedRows = responseData.updated_records_details.map(detail => detail.row).join(', ');
              message += '\nUpdated Record Count: ' + responseData.updated_records_count;
              message += '\nUpdated Record Rows: ' + updatedRows + '.';
              setShow(false);
              swal({
                title: responseData.message,
                text: message,
              }).then((willDelete) => {
                if (willDelete) {
                  GetTrafficsaleList(currentPage, sortConfig);
                }
              });
            }
          }
        } catch (error) {
          if (error.name === "HTTPError") {
            const errorJson = error.response.json();
            setSelectedFile("");
            setError(errorJson.message);
            document.getElementById("fileInput").value = null;
            setLoading(false);
          }
        }
      };
      setSelectedFileError("");
      setError("");
    } else {
      setSelectedFile("");
      setSelectedFileError("Please select a CSV file.");
    }
  };

  const handlBuilderClick = (e) => {
    setShow(true);
  };

  const handleFilterDateFrom = (date) => {
    setNormalFilter(true);
    if (date) {
      const formattedDate = date.toLocaleDateString('en-US'); // Formats date to "MM/DD/YYYY"

      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        from: formattedDate,
      }));
    } else {
      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        from: '',
      }));
    }
  };

  const handleFilterDateTo = (date) => {
    setNormalFilter(true);
    if (date) {
      const formattedDate = date.toLocaleDateString('en-US'); // Formats date to "MM/DD/YYYY"

      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        to: formattedDate,
      }));
    } else {
      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        to: '',
      }));
    }
  };

  const parseDate = (dateString) => {
    const [month, day, year] = dateString.split('/');
    return new Date(year, month - 1, day);
  };

  const totalSumFields = (field) => {
    if (field == "weeklytraffic") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.weeklytraffic || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.weeklytraffic || 0);
        }, 0);
      }
    }
    if (field == "grosssales") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.grosssales || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.grosssales || 0);
        }, 0);
      }
    }
    if (field == "cancelations") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.cancelations || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.cancelations || 0);
        }, 0);
      }
    }
    if (field == "netsales") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.netsales || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.netsales || 0);
        }, 0);
      }
    }
    if (field == "totallots") {      
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.totallots || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.totallots || 0);
        }, 0);
      }
    }
    if (field == "lotreleased") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.lotreleased || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.lotreleased || 0);
        }, 0);
      }
    }
    if (field == "unsoldinventory") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.unsoldinventory || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.unsoldinventory || 0);
        }, 0);
      }
    }
    if (field == "lotwidth") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.lotwidth || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.lotwidth || 0);
        }, 0);
      }
    }
    if (field == "lotsize") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.lotsize || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.lotsize || 0);
        }, 0);
      }
    }
    if (field == "avg_base_price_all") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_base_price_all || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_base_price_all || 0);
        }, 0);
      }
    }
    if (field == "avg_base_price_active") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_base_price_active || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_base_price_active || 0);
        }, 0);
      }
    }
    if (field == "avg_sqft_all") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_sqft_all || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_sqft_all || 0);
        }, 0);
      }
    }
    if (field == "avg_sqft_active") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_sqft_active || 0);
        }, 0);
      } else {
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_sqft_active || 0);
        }, 0);
      }
    }
    if (field == "month_net_sold") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.month_net_sold || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.month_net_sold || 0);
        }, 0);
      }
    }
    if (field == "year_net_sold") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.year_net_sold || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.year_net_sold || 0);
        }, 0);
      }
    }
    if (field == "avg_net_sales_per_month_since_open") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_net_sales_per_month_since_open || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.avg_net_sales_per_month_since_open || 0);
        }, 0);
      }
    }
    // if (field == "avg_net_sales_per_month_last_three_months") {
    //   if (filter) {
    //     return trafficsaleList.reduce((sum, traficSales) => {
    //       return sum + (traficSales.subdivision && traficSales.subdivision.avg_net_sales_per_month_last_three_months || 0);
    //     }, 0);
    //   } else {
        
    //     return AllTrafficListExport.reduce((sum, traficSales) => {
    //       return sum + (traficSales.subdivision && traficSales.subdivision.avg_net_sales_per_month_last_three_months || 0);
    //     }, 0);
    //   }
    // }
    if (field == "min_sqft_active") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.min_sqft_active || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.min_sqft_active || 0);
        }, 0);
      }
    }
    if (field == "max_sqft_active") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.max_sqft_active || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.max_sqft_active || 0);
        }, 0);
      }
    }
    if (field == "min_base_price_active") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.min_base_price_active || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.min_base_price_active || 0);
        }, 0);
      }
    }
    if (field == "max_base_price_active") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.max_base_price_active || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.max_base_price_active || 0);
        }, 0);
      }
    }
    if (field == "total_net_sales") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.total_net_sales || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.total_net_sales || 0);
        }, 0);
      }
    }
    if (field == "weekly_Unsold_Lots") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.unsoldlots || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.unsoldlots || 0);
        }, 0);
      }
    }
    if (field == "net_Sales_Per_Month_Last_3_Months") {
      if (filter) {
        return trafficsaleList.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision.net_sales_per_month_last_three_months || 0);
        }, 0);
      } else {
        
        return AllTrafficListExport.reduce((sum, traficSales) => {
          return sum + (traficSales.subdivision && traficSales.subdivision?.net_sales_per_month_last_three_months || 0);
        }, 0);
      }
    }
  };

  const averageFields = (field) => {
    const sum = totalSumFields(field);
    if (filter) {
      return sum / trafficsaleList.length;
    } else {
      return sum / AllTrafficListExport.length;
    }
  };

  const handleSelectChange = (value, field) => {
    setCalculationData((prevData) => ({
      ...prevData,
      [field]: value,  // Store field and value together
    }));

    switch (field) {
      case "weeklytraffic":
        setWeeklyTrafficOption(value);

        if (value === 'sum') {
          setWeeklyTrafficResult(totalSumFields(field));
        } else if (value === 'avg') {
          setWeeklyTrafficResult(averageFields(field));
        }
        break;

      case "grosssales":
        setWeeklyGrossSalesOption(value);

        if (value === 'sum') {
          setWeeklyGrossSalesResult(totalSumFields(field));
        } else if (value === 'avg') {
          setWeeklyGrossSalesResult(averageFields(field));
        }
        break;

      case "cancelations":
        setWeeklyCancellationsOption(value);

        if (value === 'sum') {
          setWeeklyCancellationsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setWeeklyCancellationsResult(averageFields(field));
        }
        break;

      case "netsales":
        setWeeklyNetSalesOption(value);

        if (value === 'sum') {
          setWeeklyNetSalesResult(totalSumFields(field));
        } else if (value === 'avg') {
          setWeeklyNetSalesResult(averageFields(field));
        }
        break;

      case "totallots":
        setTotalLotsOption(value);

        if (value === 'sum') {
          setTotalLotsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setTotalLotsResult(averageFields(field));
        }
        break;

      case "lotreleased":
        setWeeklyLotsReleaseForSaleOption(value);

        if (value === 'sum') {
          setWeeklyLotsReleaseForSaleResult(totalSumFields(field));
        } else if (value === 'avg') {
          setWeeklyLotsReleaseForSaleResult(averageFields(field));
        }
        break;

      case "unsoldinventory":
        setWeeklyUnsoldStandingInventoryOption(value);

        if (value === 'sum') {
          setWeeklyUnsoldStandingInventoryResult(totalSumFields(field));
        } else if (value === 'avg') {
          setWeeklyUnsoldStandingInventoryResult(averageFields(field));
        }
        break;

      case "lotwidth":
        setLotWidthOption(value);

        if (value === 'sum') {
          setLotWidthResult(totalSumFields(field));
        } else if (value === 'avg') {
          setLotWidthResult(averageFields(field));
        }
        break;

      case "lotsize":
        setLotSizeOption(value);

        if (value === 'sum') {
          setLotSizeResult(totalSumFields(field));
        } else if (value === 'avg') {
          setLotSizeResult(averageFields(field));
        }
        break;

      case "avg_base_price_all":
        setAvgBasePriceAllOption(value);

        if (value === 'sum') {
          setAvgBasePriceAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgBasePriceAllResult(averageFields(field));
        }
        break;

      case "avg_base_price_active":
        setAvgBasePriceActiveOption(value);

        if (value === 'sum') {
          setAvgBasePriceActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgBasePriceActiveResult(averageFields(field));
        }
        break;

      case "avg_sqft_all":
        setAvgSqftAllOption(value);

        if (value === 'sum') {
          setAvgSqftAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgSqftAllResult(averageFields(field));
        }
        break;

      case "avg_sqft_active":
        setAvgSqftActiveOption(value);

        if (value === 'sum') {
          setAvgSqftActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgSqftActiveResult(averageFields(field));
        }
        break;

      case "weekly_Unsold_Lots":
        setweeklyUnsoldLotsOption(value);

        if (value === 'sum') {
          setWeeklyUnsoldLotsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setWeeklyUnsoldLotsResult(averageFields(field));
        }
        break;

      case "month_net_sold":
        setMonthNetSoldOption(value);

        if (value === 'sum') {
          setMonthNetSoldResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMonthNetSoldResult(averageFields(field));
        }
        break;

      case "year_net_sold":
        setYearNetSoldOption(value);

        if (value === 'sum') {
          setYearNetSoldResult(totalSumFields(field));
        } else if (value === 'avg') {
          setYearNetSoldResult(averageFields(field));
        }
        break;
      
      case "total_net_sales":
        setTotalNetSalesOption(value);

        if (value === 'sum') {
          setTotalNetSalesResult(totalSumFields(field));
        } else if (value === 'avg') {
          setTotalNetSalesResult(averageFields(field));
        }
        break;

      case "avg_net_sales_per_month_since_open":
        setAvgNetSalesPerMonthSinceOpenOption(value);

        if (value === 'sum') {
          setAvgNetSalesPerMonthSinceOpenResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgNetSalesPerMonthSinceOpenResult(averageFields(field));
        }
        break;

      // case "avg_net_sales_per_month_last_three_months":
      //   setAvgNetSalesPerMonthLastThreeMonthsOption(value);

      //   if (value === 'sum') {
      //     setAvgNetSalesPerMonthLastThreeMonthsResult(totalSumFields(field));
      //   } else if (value === 'avg') {
      //     setAvgNetSalesPerMonthLastThreeMonthsResult(averageFields(field));
      //   }
      //   break;

      case "min_sqft_active":
        setMinSqftActiveOption(value);

        if (value === 'sum') {
          setMinSqftActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMinSqftActiveResult(averageFields(field));
        }
        break;

      case "max_sqft_active":
        setMaxSqftActiveOption(value);

        if (value === 'sum') {
          setMaxSqftActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMaxSqftActiveResult(averageFields(field));
        }
        break;

      case "min_base_price_active":
        setMinBasePriceActiveOption(value);

        if (value === 'sum') {
          setMinBasePriceActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMinBasePriceActiveResult(averageFields(field));
        }
        break;

      case "max_base_price_active":
        setMaxBasePriceActiveOption(value);

        if (value === 'sum') {
          setMaxBasePriceActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMaxBasePriceActiveResult(averageFields(field));
        }
        break;

      case "net_Sales_Per_Month_Last_3_Months":
        setNetSalesPerMonthOption(value);

        if (value === 'sum') {
          setNetSalesPerMonthResult(totalSumFields(field));
        } else if (value === 'avg') {
          setNetSalesPerMonthResult(averageFields(field));
        }
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    const trafficID = JSON.parse(localStorage.getItem("traffic_id"));
    if (trafficID) {
      handleRowClick(trafficID);
    }
  }, []);
  useEffect(() => {
    const fieldOptions = fieldList
      .filter((field) => field !== 'Action' && field !== 'Avg Base Price All' && field !== 'Avg Base Price Active' && field !== 'Avg Sqft All' && field !== 'Avg Sqft Active' && field !== 'Sqft Group' && field !== 'Price Group' && field !== 'Weekly Unsold Lots')
      .map((field) => {
        let value = field.charAt(0).toLowerCase() + field.slice(1).replace(/\s+/g, '');

        if (value === 'weekEnding') {
          value = 'weekending';
        }
        if (value === 'weeklyTraffic') {
          value = 'weeklytraffic';
        }
        if (value === 'weeklyGrossSales') {
          value = 'grosssales';
        }
        if (value === 'weeklyCancellations') {
          value = 'cancelations';
        }
        if (value === 'weeklyNetSales') {
          value = 'netsales';
        }
        if (value === 'totalLots') {
          value = 'totallots';
        }
        if (value === 'weeklyLotsReleasedforSales') {
          value = 'lotreleased';
        }
        if (value === 'weeklyUnsoldStandingInventory') {
          value = 'unsoldinventory';
        }
        if (value === 'productType') {
          value = 'product_type';
        }
        if (value === 'area') {
          value = 'area';
        }
        if (value === 'masterPlan') {
          value = 'masterplan_id';
        }
        if (value === 'zIPCode') {
          value = 'zipcode';
        }
        if (value === 'lotWidth') {
          value = 'lotwidth';
        }
        if (value === 'lotSize') {
          value = 'lotsize';
        }
        if (value === 'zoning') {
          value = 'zoning';
        }
        if (value === 'ageRestricted') {
          value = 'age';
        }
        if (value === 'allSingleStory') {
          value = 'single';
        }
        if (value === 'gasProvider') {
          value = 'gasprovider';
        }
        if (value === 'dateAdded') {
          value = 'created_at';
        }
        if (value === '__pkRecordID') {
          value = 'id';
        }
        if (value === '_fkSubID') {
          value = 'subdivision_code';
        }

        return {
          value: value,
          label: field,
        };
      });
    setFieldOptions(fieldOptions);
  }, [fieldList]);

  useEffect(() => {
    if (fieldOptions.length > 0) {
      const IDEAL_DEFAULTS = [
        { label: "Builder Name", value: "builderName" },
        { label: "Subdivision Name", value: "subdivisionName" }
      ];

      const savedString = localStorage.getItem("selectedFieldsTraffics");
      const savedFields = savedString ? JSON.parse(savedString) : [];

      let validSelectedFields = [];

      const isDefaultSubset = savedFields.length === 0 || savedFields.every(savedField =>
        IDEAL_DEFAULTS.some(def => def.value === savedField.value)
      );

      if (isDefaultSubset) {
        validSelectedFields = IDEAL_DEFAULTS.filter(def =>
          fieldOptions.some(option => option.value === def.value)
        );
      } else {
        validSelectedFields = savedFields.filter(selected =>
          fieldOptions.some(option => option.value === selected.value)
        );
      }

      const newSelectionOrder = {};
      validSelectedFields.forEach((field, index) => {
        newSelectionOrder[field.value] = index + 1;
      });

      const newSortOrders = { ...sortOrders };
      validSelectedFields.forEach(field => {
        if (!newSortOrders[field.value]) {
          newSortOrders[field.value] = 'asc';
        }
      });

      Object.keys(newSortOrders).forEach(key => {
        if (!validSelectedFields.some(f => f.value === key)) {
          delete newSortOrders[key];
        }
      });

      setSelectedFields(validSelectedFields);
      setSelectionOrder(newSelectionOrder);
      setSortOrders(newSortOrders);

      const newSortConfig = validSelectedFields.map((field) => ({
        key: field.value,
        direction: newSortOrders[field.value] || 'asc',
      }));

      localStorage.setItem("sortConfigTraffics", JSON.stringify(newSortConfig));
      setSortConfig(newSortConfig);

      const targetPage = page === null ? currentPage : JSON.parse(page);
      GetTrafficsaleList(targetPage, newSortConfig);
    }
  }, [fieldOptions]);

  useEffect(() => {
    if (showPopup) {
      setSelectedFields([]);
      setSortOrders({});
    }
  }, [showPopup]);

  const HandleSortingPopupDetailClick = (e) => {
    setShowSortingPopup(true);
  };

  const handleApplySorting = () => {
    const sortingConfig = selectedFields.map((field) => ({
      key: field.value,
      direction: sortOrders[field.value] || 'asc',
    }));
    localStorage.setItem("sortConfigTraffics", JSON.stringify(sortingConfig));
    setSortConfig(sortingConfig);
    GetTrafficsaleList(currentPage, sortingConfig);
    handleSortingPopupClose();
  };

  const handleSortingCheckboxChange = (e, field) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedFields([...selectedFields, field]);
      setSelectionOrder((prevOrder) => ({
        ...prevOrder,
        [field.value]: Object.keys(prevOrder).length + 1,
      }));
    } else {
      setSelectedFields(selectedFields.filter((selected) => selected.value !== field.value));
      setSelectionOrder((prevOrder) => {
        const newOrder = { ...prevOrder };
        delete newOrder[field.value];
        const remainingFields = selectedFields.filter((selected) => selected.value !== field.value);
        remainingFields.forEach((field, index) => {
          newOrder[field.value] = index + 1;
        });
        return newOrder;
      });
    }
  };

  const handleSortOrderChange = (fieldValue, order) => {
    setSortOrders({
      ...sortOrders,
      [fieldValue]: order,
    });
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedFields(fieldOptions);
      const newOrder = {};
      fieldOptions.forEach((field, index) => {
        newOrder[field.value] = index + 1;
      });
      setSelectionOrder(newOrder);
    } else {
      setSelectedFields([]);
      setSelectionOrder({});
    }
  };

  const handleMainCheckboxChange = (e) => {
    setSamePage(currentPage);
    if (e.target.checked) {
      Swal.fire({
        title: "Select Records",
        html: `
            <div style="text-align: left;">
              <label>
                <input type="radio" name="selection" value="visible" checked />
                Select visible records
              </label>
              <br />
              <label>
                <input type="radio" name="selection" value="all" />
                Select all records
              </label>
            </div>
          `,
        confirmButtonText: "Apply",
        showCancelButton: false,
        preConfirm: () => {
          const selectedOption = document.querySelector('input[name="selection"]:checked').value;
          return selectedOption;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedOption = result.value;
          if (selectedOption === "visible") {
            setIsSelectAll(false);
            setSelectCheckBox(true);
            setSelectedLandSales(trafficsaleList?.map((user) => user.id));
          } else if (selectedOption === "all") {
            setIsSelectAll(true);
            setSelectCheckBox(true);
            setSelectedLandSales(AllTrafficListExport?.map((user) => user.id));
          }
        }
      });
    } else {
      setSelectCheckBox(false);
      setSelectedLandSales([]);
    }
  };

  return (
    <Fragment>
      <MainPagetitle
        mainTitle="Weekly Traffic & Sales"
        pageTitle="Weekly Traffic & Sales"
        parentTitle="Home"
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center pb-3">
                    <div className="d-flex text-nowrap justify-content-between align-items-center">
                      <h4 className="heading mb-0">
                        Weekly Traffic & Sales List
                      </h4>
                      <div
                        className="btn-group mx-5"
                        role="group"
                        aria-label="Basic example"
                      >
                      </div>
                      <ColumnReOrderPopup
                        open={openDialog}
                        fieldList={fieldList}
                        handleCloseDialog={handleCloseDialog}
                        handleSaveDialog={handleSaveDialog}
                        draggedColumns={draggedColumns}
                        handleColumnOrderChange={handleColumnOrderChange}
                      />
                    </div>

                    <div className="mt-2" style={{ width: "100%" }}>
                      {(SyestemUserRole == "Admin" || SyestemUserRole == "Staff") ? (
                        <div className="d-flex">
                          <button className="btn btn-primary btn-sm me-1" onClick={handleOpenDialog} title="Column Order">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-list"></i>&nbsp;
                              Column Order
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={HandleSortingPopupDetailClick}
                            title="Sorted Fields"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-sort"></i>&nbsp;
                              Sort
                            </div>
                          </Button>
                          <button disabled={excelDownload || trafficsaleList?.length === 0} onClick={() => setExportModelShow(true)} className="btn btn-primary btn-sm me-1" title="Export .csv">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-file-export" />&nbsp;
                              {excelDownload ? "Downloading..." : "Export"}
                            </div>
                          </button>
                          {/* <Dropdown className="d-inline-block me-1">
                            <Dropdown.Toggle variant="success" className="btn-sm" id="filter-dropdown">
                              <div style={{ fontSize: "11px", display: "inline-block" }}>
                                <i className="fa fa-filter" />&nbsp;
                                Filter
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: '170px', height: 'auto', overflowY: "hidden" }}>
                              <Dropdown.Item onClick={() => setManageFilterOffcanvas(true)}>
                                Filter
                              </Dropdown.Item>

                              {!excelLoading && (
                                <Dropdown.Item onClick={() => setManageCalculationFilterOffcanvas(true)}>
                                  Calculation Filter
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown> */}
                          <button className="btn btn-success btn-sm me-1" onClick={() => setManageFilterOffcanvas(true)} title="Filter">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-filter" />&nbsp;
                              Filter
                            </div>
                          </button>
                          <button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() => setManageAccessOffcanvas(true)}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-shield" />&nbsp;
                              Field Access
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={handlBuilderClick}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-file-import" />&nbsp;
                              Import
                            </div>
                          </Button>
                          <Link
                            to={"#"}
                            className="btn btn-primary btn-sm ms-1"
                            data-bs-toggle="offcanvas"
                            onClick={() => seCanvasShowAdd(true)}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-plus" />&nbsp;
                              Add Weekly Traffic & Sale
                            </div>
                          </Link>
                          <Link
                            to={"#"}
                            className="btn btn-primary btn-sm ms-1"
                            data-bs-toggle="offcanvas"
                            onClick={() => selectedLandSales.length > 0 ? seCanvasShowEdit(true) : swal({
                              text: "Please select at least one record.",
                              icon: "warning",
                              dangerMode: true,
                            })}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-pencil" />&nbsp;
                              Edit
                            </div>
                          </Link>
                          <button
                            className="btn btn-danger btn-sm me-1"
                            style={{ marginLeft: "3px" }}
                            onClick={() => selectedLandSales.length > 0 ? swal({
                              title: "Are you sure?",
                              icon: "warning",
                              buttons: true,
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                handleBulkDelete(selectedLandSales);
                              }
                            }) : ""}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-trash" />&nbsp;
                              Delete
                            </div>
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex" style={{ marginTop: "10px" }}>
                          <button className="btn btn-primary btn-sm me-1" onClick={handleOpenDialog} title="Column Order">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-list" />&nbsp;
                              Column Order
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={HandleSortingPopupDetailClick}
                            title="Sorted Fields"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-sort" />&nbsp;
                              Sort
                            </div>
                          </Button>
                          {SyestemUserRole != "Tester" &&
                            <button disabled={excelDownload || trafficsaleList?.length === 0} onClick={() => setExportModelShow(true)} className="btn btn-primary btn-sm me-1" title="Export .csv">
                              <div style={{ fontSize: "11px" }}>
                                <i className="fas fa-file-export" />&nbsp;
                                {excelDownload ? "Downloading..." : "Export"}
                              </div>
                            </button>
                          }
                          {/* <Dropdown className="d-inline-block me-1">
                            <Dropdown.Toggle variant="success" className="btn-sm" id="filter-dropdown">
                              <div style={{ fontSize: "11px", display: "inline-block" }}>
                                <i className="fa fa-filter" />&nbsp;
                                Filter
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: '170px', height: 'auto', overflowY: "hidden" }}>
                              <Dropdown.Item onClick={() => setManageFilterOffcanvas(true)}>
                                Filter
                              </Dropdown.Item>

                              {!excelLoading && (
                                <Dropdown.Item onClick={() => setManageCalculationFilterOffcanvas(true)}>
                                  Calculation Filter
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown> */}
                          <button className="btn btn-success btn-sm me-1" onClick={() => setManageFilterOffcanvas(true)} title="Filter">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-filter" />&nbsp;
                              Filter
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {trafficListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${currentPage === n ? "current" : ""
                                    } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer padding-decreases"
                  >
                    {isLoading || columns.length === 0 ? (
                      <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                      </div>
                    ) : (
                      <table
                        id="empoloyees-tblwrapper"
                        className="table ItemsCheckboxSec dataTable no-footer mb-0 traffic-table"
                      >
                        <thead>
                          <tr style={{ textAlign: "center" }}>
                            {" "}
                            <th>
                              <input
                                type="checkbox"
                                style={{ cursor: "pointer" }}
                                checked={(currentPage == samePage || isSelectAll) ? selectCheckBox : ""}
                                onClick={(e) => handleMainCheckboxChange(e)}
                              />
                            </th>
                            <th>No.</th>
                            {columns.map((column) => (
                              <th style={{ textAlign: "center", cursor: "pointer" }} key={column.id}>
                                <strong>
                                  {column.label}
                                  {column.id != "action" && sortConfig.some(
                                    (item) => item.key === (
                                      column.id == "week Ending" ? "weekending" :
                                      column.id == "weekly Traffic" ? "weeklytraffic" :
                                      column.id == "weekly Gross Sales" ? "grosssales" :
                                      column.id == "weekly Cancellations" ? "cancelations" :
                                      column.id == "weekly Net Sales" ? "netsales" :
                                      column.id == "total Lots" ? "totallots" :
                                      column.id == "weekly Lots Released for Sales" ? "lotreleased" :
                                      column.id == "weekly Unsold Standing Inventory" ? "unsoldinventory" :
                                      column.id == "product Type" ? "product_type" :
                                      column.id == "area" ? "area" :
                                      column.id == "master Plan" ? "masterplan_id" :
                                      column.id == "zIP Code" ? "zipcode" :
                                      column.id == "lot Width" ? "lotwidth" :
                                      column.id == "lot Size" ? "lotsize" :
                                      column.id == "zoning" ? "zoning" :
                                      column.id == "age Restricted" ? "age" :
                                      column.id == "all Single Story" ? "single" :
                                      column.id == "gas Provider" ? "gasprovider" :
                                      column.id == "date Added" ? "created_at" :
                                      column.id == "__pkRecordID" ? "id" :
                                      column.id == "_fkSubID" ? "subdivision_code" : toCamelCase(column.id))
                                  ) && (
                                      <span>
                                        {column.id != "action" && sortConfig.find(
                                          (item) => item.key === (column.id == "week Ending" ? "weekending" :
                                            column.id == "weekly Traffic" ? "weeklytraffic" :
                                            column.id == "weekly Gross Sales" ? "grosssales" :
                                            column.id == "weekly Cancellations" ? "cancelations" :
                                            column.id == "weekly Net Sales" ? "netsales" :
                                            column.id == "total Lots" ? "totallots" :
                                            column.id == "weekly Lots Released for Sales" ? "lotreleased" :
                                            column.id == "weekly Unsold Standing Inventory" ? "unsoldinventory" :
                                            column.id == "product Type" ? "product_type" :
                                            column.id == "area" ? "area" :
                                            column.id == "master Plan" ? "masterplan_id" :
                                            column.id == "zIP Code" ? "zipcode" :
                                            column.id == "lot Width" ? "lotwidth" :
                                            column.id == "lot Size" ? "lotsize" :
                                            column.id == "zoning" ? "zoning" :
                                            column.id == "age Restricted" ? "age" :
                                            column.id == "all Single Story" ? "single" :
                                            column.id == "gas Provider" ? "gasprovider" :
                                            column.id == "date Added" ? "created_at" :
                                            column.id == "__pkRecordID" ? "id" :
                                            column.id == "_fkSubID" ? "subdivision_code" : toCamelCase(column.id))
                                        ).direction === "asc" ? "↑" : "↓"}
                                      </span>
                                    )}
                                </strong>

                                {(!excelLoading) && (column.id !== "week Ending" && column.id !== "builder Name" && column.id !== "subdivision Name" && column.id !== "product Type" &&
                                  column.id !== "address Name" && column.id !== "parcel Number" && column.id !== "contractor" && column.id !== "owner" && column.id !== "open Since" &&
                                  column.id !== "area" && column.id !== "master Plan" && column.id !== "zIP Code" && column.id !== "zoning" && column.id !== "age Restricted" &&
                                  column.id !== "all Single Story" && column.id !== "gas Provider" && column.id !== "date Added" && column.id !== "__pkRecordID" && column.id !== "_fkSubID" && column.id !== "action" &&
                                  column.id !== "sqft Group" && column.id !== "jurisdiction" && column.id !== "price Group"
                                ) &&
                                  (
                                    <>
                                      <br />
                                      <select className="custom-select"
                                        value={
                                          column.id == "weekly Traffic" ? weeklyTrafficOption :
                                          column.id == "weekly Gross Sales" ? weeklyGrossSalesOption :
                                          column.id == "weekly Cancellations" ? weeklyCancellationsOption :
                                          column.id == "weekly Net Sales" ? weeklyNetSalesOption :
                                          column.id == "total Lots" ? totalLotsOption :
                                          column.id == "weekly Lots Released for Sales" ? weeklyLotsReleaseForSaleOption :
                                          column.id == "weekly Unsold Standing Inventory" ? weeklyUnsoldStandingInventoryOption :
                                          column.id == "lot Width" ? lotWidthOption : 
                                          column.id == "lot Size" ? lotSizeOption : 
                                          column.id == "avg Base Price All" ? avgBasePriceAllOption : 
                                          column.id == "avg Base Price Active" ? avgBasePriceActiveOption :
                                          column.id == "avg Sqft All" ? avgSqftAllOption : 
                                          column.id == "avg Sqft Active" ? avgSqftActiveOption :
                                          column.id == "weekly Unsold Lots" ? weeklyUnsoldLotsOption :
                                          column.id == "month Net Sold" ? monthNetSoldOption :
                                          column.id == "year Net Sold" ? yearNetSoldOption :
                                          column.id == "avg Net Sales Per Month Since Open" ? avgNetSalesPerMonthSinceOpenOption :
                                          // column.id == "avg Net Sales Per Month Last 3 Months" ? avgNetSalesPerMonthLastThreeMonthsOption :
                                          column.id == "min Sqft Active" ? minSqftActiveOption :
                                          column.id == "max Sqft Active" ? maxSqftActiveOption :
                                          column.id == "min Base Price Active" ? minBasePriceActiveOption :
                                          column.id == "max Base Price Active" ? maxBasePriceActiveOption :
                                          column.id == "total Net Sales" ? totalNetSalesOption :
                                          column.id == "net Sales Per Month Last 3 Months" ? netSalesPerMonthOption : ""
                                        }

                                        style={{
                                          cursor: "pointer",
                                          marginLeft: '0px',
                                          fontSize: "8px",
                                          padding: " 0 5px 0",
                                          height: "15px",
                                          color: "white",
                                          appearance: "auto"
                                        }}

                                        onChange={(e) => column.id == "weekly Traffic" ? handleSelectChange(e.target.value, "weeklytraffic") :
                                          column.id == "weekly Gross Sales" ? handleSelectChange(e.target.value, "grosssales") :
                                          column.id == "weekly Cancellations" ? handleSelectChange(e.target.value, "cancelations") :
                                          column.id == "weekly Net Sales" ? handleSelectChange(e.target.value, "netsales") :
                                          column.id == "total Lots" ? handleSelectChange(e.target.value, "totallots") :
                                          column.id == "weekly Lots Released for Sales" ? handleSelectChange(e.target.value, "lotreleased") :
                                          column.id == "weekly Unsold Standing Inventory" ? handleSelectChange(e.target.value, "unsoldinventory") :
                                          column.id == "lot Width" ? handleSelectChange(e.target.value, "lotwidth") :
                                          column.id == "lot Size" ? handleSelectChange(e.target.value, "lotsize") : 
                                          column.id == "avg Base Price All" ? handleSelectChange(e.target.value, "avg_base_price_all") : 
                                          column.id == "avg Base Price Active" ? handleSelectChange(e.target.value, "avg_base_price_active") : 
                                          column.id == "avg Sqft All" ? handleSelectChange(e.target.value, "avg_sqft_all"): 
                                          column.id == "avg Sqft Active" ? handleSelectChange(e.target.value, "avg_sqft_active"):
                                          column.id == "month Net Sold" ? handleSelectChange(e.target.value, "month_net_sold"):
                                          column.id == "year Net Sold" ? handleSelectChange(e.target.value, "year_net_sold"):
                                          column.id == "avg Net Sales Per Month Since Open" ? handleSelectChange(e.target.value, "avg_net_sales_per_month_since_open"):
                                          // column.id == "avg Net Sales Per Month Last 3 Months" ? handleSelectChange(e.target.value, "avg_net_sales_per_month_last_three_months"):
                                          column.id == "min Sqft Active" ? handleSelectChange(e.target.value, "min_sqft_active"):
                                          column.id == "max Sqft Active" ? handleSelectChange(e.target.value, "max_sqft_active"):
                                          column.id == "min Base Price Active" ? handleSelectChange(e.target.value, "min_base_price_active"):
                                          column.id == "max Base Price Active" ? handleSelectChange(e.target.value, "max_base_price_active"):
                                          column.id == "total Net Sales" ? handleSelectChange(e.target.value, "total_net_sales"):
                                          column.id == "weekly Unsold Lots" ? handleSelectChange(e.target.value, "weekly_Unsold_Lots"):
                                          column.id == "net Sales Per Month Last 3 Months" ? handleSelectChange(e.target.value, "net_Sales_Per_Month_Last_3_Months") : ""}
                                          
                                      >
                                        <option style={{ color: "black", fontSize: "10px" }} value="" disabled>CALCULATION</option>
                                        <option style={{ color: "black", fontSize: "10px" }} value="sum">Sum</option>
                                        <option style={{ color: "black", fontSize: "10px" }} value="avg">Avg</option>
                                      </select>
                                      <br />
                                    </>
                                  )}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {!excelLoading &&
                            <tr>
                              <td></td>
                              <td></td>
                              {columns.map((column) => (
                                <>
                                  {column.id == "week Ending" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "builder Name" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "subdivision Name" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "area" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "product Type" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "weekly Traffic" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{weeklyTrafficResult.toFixed(2)}</td>
                                  }
                                  {column.id == "weekly Gross Sales" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{weeklyGrossSalesResult.toFixed(2)}</td>
                                  }
                                  {column.id == "weekly Cancellations" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{weeklyCancellationsResult.toFixed(2)}</td>
                                  }
                                  {column.id == "weekly Net Sales" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{weeklyNetSalesResult.toFixed(2)}</td>
                                  }
                                  {column.id == "month Net Sold" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{monthNetSoldResult.toFixed(2)}</td>
                                  }
                                  {column.id == "year Net Sold" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{yearNetSoldResult.toFixed(2)}</td>
                                  }
                                  {column.id == "total Lots" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{totalLotsResult.toFixed(2)}</td>
                                  }
                                  {column.id == "weekly Lots Released for Sale" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{weeklyLotsReleaseForSaleResult.toFixed(2)}</td>
                                  }
                                  {column.id == "weekly Unsold Lots" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{weeklyUnsoldLotsResult.toFixed(2)}</td>
                                  }
                                  {column.id == "total Net Sales" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{totalNetSalesResult.toFixed(2)}</td>
                                  }
                                  {column.id == "open Since" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "avg Net Sales Per Month Since Open" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{avgNetSalesPerMonthSinceOpenResult.toFixed(2)}</td>
                                  }
                                  {column.id == "net Sales Per Month Last 3 Months" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{netSalesPerMonthResult.toFixed(2)}</td>
                                  }
                                  {/* {column.id == "avg Net Sales Per Month Last 3 Months" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{avgNetSalesPerMonthLastThreeMonthsResult.toFixed(2)}</td>
                                  } */}
                                  {column.id == "weekly Unsold Standing Inventory" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{weeklyUnsoldStandingInventoryResult.toFixed(2)}</td>
                                  }
                                  {column.id == "min Sqft Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={minSqftActiveResult} />}</td>
                                  }
                                  {column.id == "max Sqft Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={maxSqftActiveResult} />}</td>
                                  }
                                  {column.id == "min Base Price Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={minBasePriceActiveResult} />}</td>
                                  }
                                  {column.id == "max Base Price Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={maxBasePriceActiveResult} />}</td>
                                  }
                                  {column.id == "master Plan" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "zIP Code" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "__pkRecordID" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "_fkSubID" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "age Restricted" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "all Single Story" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "avg Base Price Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={avgBasePriceActiveResult} />}</td>
                                  }
                                  {column.id == "avg Base Price All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={avgBasePriceAllResult} />}</td>
                                  }
                                  {column.id == "avg Sqft Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{avgSqftActiveResult.toFixed(2)}</td>
                                  }
                                  {column.id == "avg Sqft All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{avgSqftAllResult.toFixed(2)}</td>
                                  }
                                  {column.id == "date Added" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "jurisdiction" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "lot Size" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{lotSizeResult.toFixed(2)}</td>
                                  }
                                  {column.id == "lot Width" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{lotWidthResult.toFixed(2)}</td>
                                  }
                                  {column.id == "price Group" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "sqft Group" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "zoning" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "gas Provider" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                  {column.id == "action" &&
                                    <td key={column.id} style={{ textAlign: "center" }}></td>
                                  }
                                </>
                              ))}
                            </tr>
                          }
                          {trafficsaleList !== null && trafficsaleList.length > 0 ? (
                            trafficsaleList.map((element, index) => (
                              <tr
                                onClick={(e) => {
                                  if (e.target.type == "checkbox") {
                                    return;
                                  } else if (e.target.className == "btn btn-danger shadow btn-xs sharp" || e.target.className == "fa fa-trash") {
                                    return;
                                  } else {
                                    handleRowClick(element.id);
                                  }
                                }}
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedLandSales.includes(element.id)}
                                    onChange={(e) => handleEditCheckboxChange(e, element.id)}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  />
                                </td>
                                <td>{index + 1}</td>
                                {columns.map((column) => (
                                  <>
                                    {column.id == "week Ending" &&
                                      <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element.weekending} /></td>
                                    }
                                    {column.id == "builder Name" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.builder?.name ?? ""}</td>
                                    }
                                    {column.id == "subdivision Name" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.name ?? ""}</td>
                                    }
                                    {column.id == "area" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.area ?? ""}</td>
                                    }
                                    {column.id == "product Type" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.product_type ?? ""}</td>
                                    }
                                    {column.id == "weekly Traffic" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.weeklytraffic ?? ""}</td>
                                    }
                                    {column.id == "weekly Gross Sales" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.grosssales ?? ""}</td>
                                    }
                                    {column.id == "weekly Cancellations" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.cancelations ?? ""}</td>
                                    }
                                    {column.id == "weekly Net Sales" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.netsales ?? ""}</td>
                                    }
                                    {column.id == "month Net Sold" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.month_net_sold ?? ""}</td>
                                    }
                                    {column.id == "year Net Sold" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.year_net_sold ?? ""}</td>
                                    }
                                    {column.id == "total Lots" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.totallots ?? ""}</td>
                                    }
                                    {column.id == "weekly Lots Released for Sale" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.lotreleased ?? ""}</td>
                                    }
                                    {column.id == "weekly Unsold Lots" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.unsoldlots ?? ""}</td>
                                    }
                                    {column.id == "total Net Sales" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.total_net_sales ?? ""}</td>
                                    }
                                    {column.id == "open Since" &&
                                      <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element?.subdivision?.opensince} /></td>
                                    }
                                    {column.id == "avg Net Sales Per Month Since Open" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.avg_net_sales_per_month_since_open ?? ""}</td>
                                    }
                                    {column.id == "net Sales Per Month Last 3 Months" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.net_sales_per_month_last_three_months ?? ""}</td>
                                    }
                                    {/* {column.id == "avg Net Sales Per Month Last 3 Months" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.avg_net_sales_per_month_last_three_months ?? ""}</td>
                                    } */}
                                    {column.id == "weekly Unsold Standing Inventory" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.unsoldinventory}</td>
                                    }
                                    {column.id == "min Sqft Active" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.subdivision.min_sqft_active} /> || "NA"}</td>
                                    }
                                    {column.id == "max Sqft Active" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.subdivision.max_sqft_active} /> || "NA"}</td>
                                    }
                                    {column.id == "min Base Price Active" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.subdivision.min_base_price_active} /> || "NA"}</td>
                                    }
                                    {column.id == "max Base Price Active" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.subdivision.max_base_price_active} /> || "NA"}</td>
                                    }
                                    {column.id == "master Plan" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.masterplan_id ?? ""}</td>
                                    }
                                    {column.id == "zIP Code" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.zipcode ?? ""}</td>
                                    }
                                    {column.id == "__pkRecordID" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.id ?? ""}</td>
                                    }
                                    {column.id == "_fkSubID" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.subdivision_code ?? ""}</td>
                                    }
                                    {column.id == "age Restricted" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision &&
                                        element.subdivision.age === 1 &&
                                        "Yes"}
                                        {element.subdivision &&
                                          element.subdivision.age === 0 &&
                                          "No"}
                                      </td>
                                    }
                                    {column.id == "all Single Story" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision &&
                                        element.subdivision.single === 1 &&
                                        "Yes"}
                                        {element.subdivision &&
                                          element.subdivision.single === 0 &&
                                          "No"}
                                      </td>
                                    }
                                    {column.id == "avg Base Price Active" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.subdivision.avg_base_price_active} /> || "NA"}</td>
                                    }
                                    {column.id == "avg Base Price All" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.subdivision.avg_base_price_all} /> || "NA"}</td>
                                    }
                                    {column.id == "avg Sqft Active" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision.avg_sqft_active}</td>
                                    }
                                    {column.id == "avg Sqft All" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision.avg_sqft_all}</td>
                                    }
                                    {column.id == "date Added" &&
                                      <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element.created_at} /></td>
                                    }
                                    {column.id == "jurisdiction" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision && element.subdivision.juridiction}</td>
                                    }
                                    {column.id == "lot Size" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision && element.subdivision?.lotsize}</td>
                                    }
                                    {column.id == "lot Width" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision && element.subdivision?.lotwidth}</td>
                                    }
                                    {column.id == "price Group" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element?.subdivision?.price_group?.group}</td>
                                    }
                                    {column.id == "sqft Group" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision.sqft_group}</td>
                                    }
                                    {column.id == "zoning" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision && element.subdivision?.zoning}</td>
                                    }
                                    {column.id == "gas Provider" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision && element.subdivision?.gasprovider}</td>
                                    }
                                    {column.id == "action" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>
                                        <div className="d-flex justify-content-center">
                                          <Link
                                            to={`/trafficsaleupdate/${element.id}?page=${currentPage}`}
                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </Link>
                                          <Link
                                            onClick={() =>
                                              swal({
                                                title: "Are you sure?",
                                                icon: "warning",
                                                buttons: true,
                                                dangerMode: true,
                                              }).then((willDelete) => {
                                                if (willDelete) {
                                                  handleDelete(element.id);
                                                }
                                              })
                                            }
                                            className="btn btn-danger shadow btn-xs sharp"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </Link>
                                        </div>
                                      </td>
                                    }
                                  </>
                                ))}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" style={{ textAlign: "center" }}>
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {trafficListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${currentPage === n ? "current" : ""
                                    } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TrafficsaleOffcanvas
        canvasShowAdd={canvasShowAdd}
        seCanvasShowAdd={seCanvasShowAdd}
        Title="Add Weekly Traffic & Sale"
        parentCallback={handleCallback}
      />

      <BulkTrafficUpdate
        canvasShowEdit={canvasShowEdit}
        seCanvasShowEdit={seCanvasShowEdit}
        Title={selectedLandSales?.length  === 1 ? "Edit Weekly Traffic & Sale" : "Bulk Edit Weekly Traffic & Sales"}
        parentCallback={handleCallback}
        selectedLandSales={selectedLandSales}
      />

      <Offcanvas
        show={showOffcanvas}
        onHide={setShowOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Weekly Traffic & Sales Details{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => { setShowOffcanvas(false); clearTrafficDetails(); }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        {isFormLoading ? (
          <div className="d-flex justify-content-center align-items-center mb-5">
            <ClipLoader color="#4474fc" />
          </div>
        ) : (
          <div className="offcanvas-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-4 mt-4">
                  <label className="">Subdivision:</label>
                  <div className="fw-bolder">
                    {TrafficDetails.subdivision !== null &&
                      TrafficDetails.subdivision.name !== undefined
                      ? TrafficDetails.subdivision.name
                      : "NA"}
                  </div>
                </div>

                <div className="col-xl-4 mt-4">
                  <label className="">Week Ending:</label>
                  <div>
                    <span className="fw-bold">
                      {<DateComponent date={TrafficDetails.weekending} /> || "NA"}
                    </span>
                  </div>
                </div>

                <div className="col-xl-4 mt-4">
                  <label className="">Weekly Traffic :</label>
                  <div>
                    <span className="fw-bold">
                      {TrafficDetails.weeklytraffic || "NA"}
                    </span>
                  </div>
                </div>

                <div className="col-xl-4 mt-4">
                  <label className="">Gross Sales :</label>
                  <div>
                    <span className="fw-bold">
                      {TrafficDetails.grosssales || "NA"}
                    </span>
                  </div>
                </div>

                <div className="col-xl-4 mt-4">
                  <label className="">Cancelations :</label>
                  <div>
                    <span className="fw-bold">
                      <span className="fw-bold">
                        {TrafficDetails.cancelations || "NA"}
                      </span>
                    </span>
                  </div>
                </div>

                <div className="col-xl-4 mt-4">
                  <label className="">Net Sales :</label>
                  <div>
                    <span className="fw-bold">
                      {TrafficDetails.netsales || "NA"}
                    </span>
                  </div>
                </div>

                <div className="col-xl-4 mt-4">
                  <label className="">Lot Released :</label>
                  <div>
                    <span className="fw-bold">
                      {TrafficDetails.lotreleased || "NA"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>)}
      </Offcanvas>

      <Offcanvas
        show={manageAccessOffcanvas}
        onHide={setManageAccessOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Manage Weekly Traffic & Sale Fields Access{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageAccessOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <label className="form-label">
              Select Role:
            </label>
            <select
              className="default-select form-control"
              name="manage_role_fields"
              onChange={HandleRole}
              value={role}
            >
              <option value="Admin">Admin</option>
              <option value="Staff">Staff</option>
              <option value="Standard User">Standard User</option>
              <option value="Data Uploader">Data Uploader</option>
              <option value="Account Admin">Account Admin</option>
            </select>
            <form onSubmit={handleAccessForm}>
              <div className="row">
                {Array.isArray(accessList) &&
                  accessList.map((element, index) => (
                    <div className="col-md-4" key={index}>
                      <div className="mt-5">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={checkedItems[element.field_name]}
                            onChange={handleCheckboxChange}
                            name={element.field_name}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`flexCheckDefault${index}`}
                          >
                            {element.field_name}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <button type="submit" className="btn btn-primary mt-3">
                Submit
              </button>
            </form>
          </div>
        </div>
      </Offcanvas>

      <Offcanvas
        show={manageFilterOffcanvas}
        onHide={setManageFilterOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Filter Weekly Traffic & Sales{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageFilterOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <div className="">
              <form onSubmit={HandleFilterForm}>
                <div className="row">
                  <div className="col-md-3 mt-3">
                    <label className="form-label">From:{" "}
                      <span className="text-danger">*</span>
                      <div className="btn-tooltip" id="from">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#from"
                              style={{ zIndex: 999 }}
                              content={<>Data runs from Monday <br /> through Sunday </>}
                            />
                        </div>
                    </label>
                    <DatePicker
                      name="from"
                      className="form-control"
                      selected={filterQuery.from ? parseDate(filterQuery.from) : null}
                      onChange={handleFilterDateFrom}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="mm/dd/yyyy"
                    />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">To:{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <DatePicker
                      name="to"
                      className="form-control"
                      selected={filterQuery.to ? parseDate(filterQuery.to) : null}
                      onChange={handleFilterDateTo}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="mm/dd/yyyy"
                    />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">
                      BUILDER NAME:{" "}
                    </label>
                    <Form.Group controlId="tournamentList">
                      <MultiSelect
                        name="builder_name"
                        options={builderDropDown}
                        value={selectedBuilderName}
                        onChange={handleSelectBuilderNameChange}
                        placeholder={"Select Builder Name"}
                        hasSelectAll={true}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">
                      SUBDIVISION NAME:{" "}
                    </label>
                    <Form.Group controlId="tournamentList">
                      <LazySubdivisionMultiSelect
                        builderIds={selectedBuilderIDByFilter}
                        name="subdivision_name"
                        value={selectedSubdivisionName}
                        onChange={handleSelectSubdivisionNameChange}
                        placeholder={"Select Subdivision Name"}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">
                      WEEKLY TRAFFIC :{" "}
                      <div className="btn-tooltip" id="weeklytraffic">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#weeklytraffic"
                              style={{ zIndex: 999 }}
                              content={<>THE NUMBER OF BUYING <br/> UNITS THAT ENTER THE SALES <br /> OFFICE. (BE-BACKS ARE <br/> COUNTED AS BUYING UNITSY) </>}
                            />
                      </div>
                    </label>
                    <input value={filterQuery.weeklytraffic} name="weeklytraffic" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">
                      WEEKLY CANCELLATIONS:{" "}
                    </label>
                    <input name="cancelations" value={filterQuery.cancelations} className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">
                      WEEKLY NET SALES:{" "}
                      <div className="btn-tooltip" id="netsales">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#netsales"
                              style={{ zIndex: 999 }}
                              content={<>GROSS SALES MINUS <br /> CANCELLATIONS</>}
                            />
                      </div>
                    </label>
                    <input name="netsales" value={filterQuery.netsales} className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">
                      TOTAL LOTS:{" "}
                    </label>
                    <input value={filterQuery.totallots} name="totallots" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">
                      WEEKLY LOTS RELEASED FOR SALES:{" "}
                      <div className="btn-tooltip" id="lotreleased">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#lotreleased"
                              style={{ zIndex: 999 }}
                              content={<>THE TOTAL NUMBER OF LOTS <br/> RELEASED FOR SALE TO DATE</>}
                            />
                      </div>
                    </label>
                    <input value={filterQuery.lotreleased} name="lotreleased" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label" style={{fontSize:12}}>
                      WEEKLY UNSOLD STANDING INVENTORY:{" "}
                      <div className="btn-tooltip" id="unsoldinventory">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#unsoldinventory"
                              style={{ zIndex: 999 }}
                              content={<>ANY UNSOLD UNIT THAT IS 30 <br/> DAYS OR LESS FROM THE <br/>  CERTIFICATE OF OCCUPANCY </>}
                            />
                      </div>
                    </label>
                    <input type="unsoldinventory" value={filterQuery.unsoldinventory} name="unsoldinventory" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      PRODUCT TYPE:{" "}
                      <div className="btn-tooltip" id="product_type">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#product_type"
                              style={{ zIndex: 999 }}
                              content={<>BET: Single Family Detached <br/> ATT: Attached le. <br/> Condo/Townhome/Duplex/etc.<br/> HR: High Rise </>}
                            />
                      </div>
                    </label>
                    <MultiSelect
                      name="product_type"
                      options={productTypeOptions}
                      value={productTypeStatus}
                      onChange={handleSelectProductTypeChange}
                      placeholder="Select Prodcut Type"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      AREA:{" "}
                      <div className="btn-tooltip" id="area">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#area"
                              style={{ zIndex: 999 }}
                              clickable={true} 
                              content={
                                <> 
                                See our Sub-Market<br /> Area Map:{" "}                                 
                                    <a
                                        href="https://www.homebuildersresearch.com/images/misc/sub_market_areas.png"
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >                      
                                    View Map
                                    </a>
                                </>}
                            />
                      </div>
                    </label>
                    <MultiSelect
                      name="area"
                      options={areaOption}
                      value={selectedArea}
                      onChange={handleSelectAreaChange}
                      placeholder="Select Area"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      MASTERPLAN:{" "}
                    </label>
                    <MultiSelect
                      name="masterplan_id"
                      options={masterPlanDropDownList}
                      value={selectedMasterPlan}
                      onChange={handleSelectMasterPlanChange}
                      placeholder="Select Area"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      ZIP CODE:{" "}
                    </label>
                    <input
                      type="text"
                      name="zipcode"
                      value={filterQuery.zipcode}
                      className="form-control"
                      onChange={HandleFilter}
                      pattern="[0-9, ]*"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9, ]/g, '');
                      }}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      LOT WIDTH:{" "}
                      <div className="btn-tooltip" id="lotwidth">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#lotwidth"
                              style={{ zIndex: 999 }}
                              content={<>Approximate average lot width</>}
                            />
                      </div>
                    </label>
                    <input value={filterQuery.lotwidth} name="lotwidth" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      LOT SIZE:{" "}
                      <div className="btn-tooltip" id="lotsize">
                        <IoMdInformationCircleOutline height={50} width={50} />
                            <Tooltip
                              anchorSelect="#lotsize"
                              style={{ zIndex: 999 }}
                              content={<>Approximate average lot size (sqft)</>}
                            />
                      </div>
                    </label>
                    <input value={filterQuery.lotsize} name="lotsize" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      ZONING:{" "}
                    </label>
                    <input value={filterQuery.zoning} name="zoning" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label htmlFor="exampleFormControlInput8" className="form-label">AGE RESTRICTED:{" "}</label>
                    <MultiSelect
                      name="age"
                      options={ageOptions}
                      value={selectedAge}
                      onChange={handleSelectAgeChange}
                      placeholder={"Select Age"}
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label htmlFor="exampleFormControlInput8" className="form-label">All SINGLE STORY:{" "}</label>
                    <MultiSelect
                      name="single"
                      options={singleOptions}
                      value={selectedSingle}
                      onChange={handleSelectSingleChange}
                      placeholder={"Select Single"}
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">GAS PROVIDER:</label>
                    <MultiSelect
                      name="gasprovider"
                      options={gasProviderDropDown}
                      value={seletctedGasProvider}
                      onChange={handleGasProviderChange}
                      placeholder="Select Gas Provider"
                      hasSelectAll={true}
                    />
                  </div>
                </div>
              </form>
            </div>
            <br />
            <>
              <h5 className="">Calculation Filter Weekly Traffic & Sales
                <div className="btn-tooltip" id="active_communites">
                  <IoMdInformationCircleOutline height={50} width={50} />
                  <Tooltip
                    anchorSelect="#active_communites"
                    style={{ zIndex: 999 }}
                    content={
                      <>
                        Use operators<br /> &lt;, &gt;, = , &lt;= , &gt;=, # (range),<br /> !(empty)
                      </>
                    }
                  />
                </div>
              </h5>
              <div className="border-top">
                <div className="row">
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">WEEKLY GROSS SALES:{" "}</label>
                    <input value={filterQueryCalculation.grosssales} name="grosssales" className="form-control" onChange={handleInputChange} />
                  </div>
                </div>
              </div>
            </>
            <div className="d-flex justify-content-between">
              <Button
                className="btn-sm"
                onClick={HandleCancelFilter}
                variant="secondary"
              >
                Reset
              </Button>
              <Button
                className="btn-sm"
                onClick={HandleFilterForm}
                variant="primary"
              >
                Filter
              </Button>
            </div>
          </div>
        </div>
      </Offcanvas>

      {/* Calculation Filter */}
      {/* <Offcanvas
        show={manageCalculationFilterOffcanvas}
        onHide={setManageCalculationFilterOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="">Calculation Filter Weekly Traffic & Sales
            <div className="btn-tooltip" id="active_communites">
              <IoMdInformationCircleOutline height={50} width={50} />
              <Tooltip
                anchorSelect="#active_communites"
                style={{ zIndex: 999 }}
                content={
                  <>
                    Use operators<br /> &lt;, &gt;, = , &lt;= , &gt;=, # (range),<br /> !(empty)
                  </>
                }
              />
            </div>
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageCalculationFilterOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <div>
              <div className="row">
                <div className="col-md-3 mt-3 mb-3">
                  <label className="form-label">WEEKLY GROSS SALES:{" "}</label>
                  <input value={filterQueryCalculation.grosssales} name="grosssales" className="form-control" onChange={handleInputChange} />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <Button
                className="btn-sm"
                variant="secondary"
                onClick={() => {
                  setFilterQueryCalculation({
                    grosssales: ""
                  });
                  setFilter(false);
                  GetTrafficsaleList(1, sortConfig);
                  setManageCalculationFilterOffcanvas(false);
                }}
              >
                Reset Calculation
              </Button>
              <Button
                className="btn-sm"
                variant="primary"
                onClick={() => {
                  setFilter(true);
                  setManageCalculationFilterOffcanvas(false);
                }}
              >
                Filter Calculation
              </Button>
            </div>

          </div>
        </div>
      </Offcanvas> */}

      <Modal show={exportmodelshow} onHide={() => setExportModelShow(true)}>
        <>
          <Modal.Header>
            <Modal.Title>Export</Modal.Title>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => { resetSelection(); setExportModelShow(false); }}
            ></button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <ul className='list-unstyled'>
                <li>
                  <label className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selectAll}
                      onChange={handleSelectAllToggle}
                    />
                    Select All
                  </label>
                </li>
                {/* {exportColumns.map((col) => ( */}
                {filteredExportColumns?.map((col) => (
                  <li key={col.label}>
                    <label className='form-check'>
                      <input
                        type="checkbox"
                        className='form-check-input'
                        checked={selectedColumns.includes(col.label)}
                        onChange={() => handleColumnToggle(col.label)}
                      />
                      {col.label}
                    </label>
                  </li>
                ))}
              </ul>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <button 
              varient="primary" 
              className="btn btn-primary"
              disabled={excelDownload}
              onClick={handleDownloadExcel}
            >
              {excelDownload ? "Downloading..." : "Download"}
            </button>
          </Modal.Footer>
        </>
      </Modal>

      {/* Sorting */}
      <Modal show={showSortingPopup} onHide={HandleSortingPopupDetailClick}>
        <Modal.Header handleSortingPopupClose>
          <Modal.Title>Sorted Fields</Modal.Title>
          <button
            className="btn-close"
            aria-label="Close"
            onClick={() => handleSortingPopupClose()}
          ></button>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <div className="row">
            <div style={{ marginTop: "-15px" }}>
              <label className="form-label" style={{ fontWeight: "bold", fontSize: "15px" }}>List of Fields:</label>
              <div className="field-checkbox-list">
                <div className="form-check d-flex align-items-center mb-2" style={{ width: '100%' }}>
                  <div className="d-flex align-items-center" style={{ flex: '0 0 40%' }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="select-all-fields"
                      checked={selectedFields.length === fieldOptions.length}
                      onChange={handleSelectAllChange}
                      style={{ marginRight: '0.2rem', cursor: "pointer" }}
                    />
                    <label className="form-check-label mb-0" htmlFor="select-all-fields" style={{ width: "150px", cursor: "pointer" }}>
                      Select All
                    </label>
                  </div>
                </div>

                {fieldOptions.map((field, index) => {
                  const isChecked = selectedFields.some(selected => selected.value === field.value);
                  const fieldOrder = selectionOrder[field.value];

                  return (
                    <div key={index} className="form-check d-flex align-items-center mb-2" style={{ width: '100%', height: "20px", marginTop: "20px" }}>
                      <div className="d-flex align-items-center" style={{ flex: '0 0 40%' }}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`field-checkbox-${index}`}
                          value={field.value}
                          checked={isChecked}
                          onChange={(e) => handleSortingCheckboxChange(e, field)}
                          style={{ marginRight: '0.2rem', cursor: "pointer" }}
                        />
                        <label className="form-check-label mb-0" htmlFor={`field-checkbox-${index}`} style={{ cursor: "pointer", width: "150px" }}>
                          {isChecked && <span>{fieldOrder}. </span>}
                          {field.label}
                        </label>
                      </div>

                      {isChecked && (
                        <div className="radio-group d-flex" style={{ flex: '0 0 60%', paddingTop: "5px" }}>
                          <div className="form-check form-check-inline" style={{ flex: '0 0 50%' }}>
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`asc-${field.value}`}
                              value="asc"
                              checked={sortOrders[field.value] === 'asc' || !sortOrders[field.value]}
                              onChange={() => handleSortOrderChange(field.value, 'asc')}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label mb-0" htmlFor={`asc-${field.value}`} style={{ cursor: "pointer", marginLeft: "-40px" }}>
                              Ascending
                            </label>
                          </div>
                          <div className="form-check form-check-inline" style={{ flex: '0 0 50%' }}>
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`desc-${field.value}`}
                              value="desc"
                              checked={sortOrders[field.value] === 'desc'}
                              onChange={() => handleSortOrderChange(field.value, 'desc')}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label mb-0" htmlFor={`desc-${field.value}`} style={{ cursor: "pointer", marginLeft: "-30px" }}>
                              Descending
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSortingPopupClose} style={{ marginRight: "10px" }}>Close</Button>
          <Button variant="success" onClick={() => handleApplySorting(selectedFields, sortOrders)}>Apply</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Import Weekly Traffic & Sales CSV Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-3">
            <input type="file" id="fileInput" onChange={handleFileChange} />
          </div>
          <p className="text-danger d-flex justify-content-center align-item-center mt-1">
            {selectedFileError || Error}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleUploadClick}
            disabled={loading}
          >
            {loading ? "Loading.." : "Import"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Popup */}
      <Modal show={showPopup} onHide={HandlePopupDetailClick}>
        <Modal.Header handlePopupClose>
          <Modal.Title>Alert</Modal.Title>
          <button
            className="btn-close"
            aria-label="Close"
            onClick={() => handlePopupClose()}
          ></button>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePopupClose}>Close</Button>
        </Modal.Footer>
      </Modal>

      <AccessField 
        tableName={"traffic"}
        setFieldList={setFieldList}
        manageAccessField={manageAccessField}
        setManageAccessField={setManageAccessField}
      />

    </Fragment>
  );
};

export default TrafficsaleList;
